import antdData from "antd/lib/locale/en_US";

const messages = {
  "loader.preparing_workspace": "Preparing your workspace",
  "loader.preparing_workspace_desc":
    "Please wait a moment, we are loading your company data.",

  "topBar.issuesHistory": "Issues History",
  "topBar.projectManagement": "Project Management",
  "topBar.typeToSearch": "Type to search...",
  "topBar.buyNow": "Buy Now $24",
  "topBar.bitcoin": "Bitcoin",
  "topBar.profileMenu.hello": "Hello",
  "topBar.profileMenu.billingPlan": "Billing Plan",
  "topBar.profileMenu.role": "Role",
  "topBar.profileMenu.email": "Email",
  "topBar.profileMenu.phone": "Phone",
  "topBar.profileMenu.editProfile": "Edit Profile",
  "topBar.profileMenu.logout": "Logout",
  "topBar.billing.plan": "Plan",
  "topBar.billing.forever": "Forever",
  "topBar.billing.active_until": "Active until",
  "topBar.streamChat.switchLabel": "Stream chat",
  "topBar.streamChat.tooltip":
    "When Stream chat is on, new conversations that enter Assigned will automatically open the Assigned tab and focus that chat, so you don't have to check them one by one manually.",
  "topBar.serverUpdateNotice.close": "Dismiss notice",

  "notification.a_new_version_is_available": "A new version is available!",
  "notification.please_wait_prepare_to_reload_page":
    "Please wait, prepare to reload page on {{countDown}} seconds. {{errorAutoReloadMessage}}",
  "notification.autoreload_failed": "Auto reload failed.",
  "notification.reload_immediately": "Reload immediately",
  "notification.login_expired": "Your session is expired!",
  "notification.login_google_failure": "Login google failure!",
  "notification.gajihub_is_now_on_google_play":
    "Gajihub is now available on Google Play",
  "notification.gajihub_is_now_on_app_store":
    "Gajihub is now available on App Store",
  "notification.install_now": "Install Now",
  "notification.later": "Later",

  "button.save": "Save",
  "button.save_add_new": "Save & Add New",
  "button.cancel": "Cancel",
  "button.add": "Add",
  "button.duplicate": "Duplicate",
  "button.import": "Import",
  "button.export": "Export",
  "button.print": "Print",
  "button.filter": "Filter",
  "button.clear_filter": "Clear Filter",
  "button.delete": "Delete",
  "button.edit": "Edit",
  "button.next": "Next",
  "button.back": "Back",
  "button.approve": "Approve",
  "button.reject": "Reject",
  "button.yes": "Yes",
  "button.no": "No",
  "button.download": "Download",
  "button.confirmation": "Confirmation",
  "button.activate": "Activate",
  "button.non_activate": "Non Activate",
  "button.detail": "Detail",
  "button.add_line": "Add Line",
  "button.select_all": "Select All",
  "button.deselect_all": "Remove All",
  "button.schedule_now": "Schedule Now",
  "button.hello_can_i_help": "Hello, can I help you?",
  "button.close": "Close",
  "button.slide_to_confirm": "Slide to confirm",
  "button.confirmed": "Confirmed!",
  "button.click_here": "Click here",
  "button.upgrade": "Upgrade",
  "button.renew": "Renew",
  "button.copy_to_clipboard": "Copy Link to Clipboard",
  "button.archive": "Archive",
  "button.unarchive": "Unarchive",
  "button.copy_link": "Copy Link",
  "button.upload": "Upload",
  "button.send": "Send",
  "button.search": "Search",
  "button.reset": "Reset",

  "message.cannot_update_data": "Cannot update data.",
  "message.cannot_return_data": "Data is not returnable.",
  "message.link_has_been_copied": "Link has been copied.",
  "message.on": "on",

  "popconfirm.title.delete": "Are you sure to delete?",
  "popconfirm.title.archive": "Are you sure to archive?",
  "popconfirm.title.unarchive": "Are you sure to unarchive?",
  "popconfirm.title.reset": "Are you sure to reset?",

  "tooltip.hidden": "Hidden",

  "validation.min": "Min {{value}}",
  "validation.max": "Max {{value}}",
  "validation.max_characters": "Max {{value}} characters",

  "input.search": "Search",
  "input.other": "Other",
  "input.all": "All",
  "input.select_year": "Select year",
  "input.select_month": "Select month",
  "input.cannot_be_empty": "Cannot be empty",

  "date.today": "Today",
  "date.yesterday": "Yesterday",
  "date.week": "Week",
  "date.this_week": "This Week",
  "date.last_week": "Last Week",
  "date.this_month": "This Month",
  "date.last_month": "Last Month",
  "date.last_7_days": "Last 7 Days",
  "date.last_30_days": "Last 30 Days",
  "date.this_year": "This Year",
  "date.last_year": "Last Year",
  "date.daily": "Daily",
  "date.monthly": "Monthly",
  "date.weekly": "Weekly",
  "date.yearly": "Yearly",
  "date.year": "Year",
  "date.month": "Month",
  "date.day": "Day",
  "date.days": "Days",
  "date.date": "Date",
  "date.hour": "Hour",
  "date.hours": "Hours",
  "date.minute": "Minute",
  "date.minutes": "Minutes",
  "date.time": "Time",
  "date.date_range": "Date Range",

  "nps.how_likely_you_recommend":
    "How likely is that you would recommend Gajihub to a friend?",
  "nps.not_likely": "Not at all likely",
  "nps.very_likely": "Very likely",
  "nps.please_mention_another":
    "Please mention something else you would like to say through comment box below",
  "nps.cannot_hide_nps": "Cannot hide NPS",
  "nps.cannot_send_nps": "Cannot send NPS",
  "nps.thank_you_your_input":
    "Thank you, your input is very meaningful. We analyze every input that comes in.",

  "users.remember_me": "Remember me",
  "users.forgot_password_": "Forgot password?",
  "users.welcome_to2": "Welcome to ",
  "users.login": "Login",
  "users.login_with_google": "Sign in with Google",
  "users.login_failed": "Login Failed",
  "users.please_log_in": "Please log in",
  "users.you_have_logged_out_automatically":
    "You have been logged out automatically, please continue to proceed.",
  "users.email_is_required": "Email is required",
  "users.email_is_not_a_valid_email": "Email is not a valid email",
  "users.please_input_your_email_address": "Please input your e-mail address",
  "users.email": "Email",
  "users.password": "Password",
  "users.please_input_your_password": "Please input your password",
  "users.hello": "Hello",
  "users.please_select_company_to_proceed":
    "please select a company to proceed",
  "users.leave_page": "Leave page?",
  "users.changes_that_you_made_may_not_be_saved":
    "Changes that you made may not be saved.",
  "users.registration_completed": "Regsitration completed!",
  "users.password_has_been_sent_to_email_sms":
    "Password has been sent to your email and sms, please check it out",
  users: "Users",
  "users.name": "Name",
  "users.roles": "Roles",
  "users.search_by_name_or_email": "Search by name or email",
  "users.search_by_name": "Search by name",
  "users.pending_invitation": "(Pending invitation)",
  "users.add_user": "Add User",
  "users.delete_user": "Delete User",
  "users.edit_user": "Edit User",
  "users.please_input_the_email_address": "Please input email address.",
  "users.max_100_characters": "Max 100 characters.",
  "users.invalid_email_address_format": "Invalid email address format.",
  "users.please_select_a_role": "Please select a role.",
  "users.select_roles": "Select Role",
  "users.information": "Information",
  "users.information_invitation_email":
    "A invitation email already sent to {{email}} . Please ask your colleague to follow the instruction in the email to activate the account. If email hasn't received please check the bulk and spam folder.",
  "users.only_displays_users_other_than_you":
    "Only displays users other than you",
  "users.please_select_a_user": "Please select a user.",
  "users.select_user": "Select user",
  "users.select_user_to_delete": "Select User to Delete",
  "users.two_passwords_that_you_enter_is_inconsistent_":
    "Two passwords that you enter is inconsistent.",
  "users.register_now": "Register now",
  "users.restore_password": "Restore Password",
  "users.enter_the_email_address_associated_with_your_account_and_well_email_you_a_link_to_reset_your_password":
    "Enter the email address associated with your account, and we'll email you a link to reset your password",
  "users.back_to_login": "Back to login",
  "users.send_reset_link": "Send Reset Link",
  "users.please_check_your_email_inbox_and_follow_the_instruction_to_reset_your_password_if_email_hasnt_received_please_check_the_bulk_and_spam_folder":
    "Please check your email inbox and follow the instruction to reset your password. If email hasn't received please check the bulk and spam folder",
  "users.reset_password": "Reset Password",
  "users.request_new_password_reset": "Request new password reset",
  "users.new_password": "New Password",
  "users.invalid_password_reset_token": "Invalid password reset token",
  "users.your_password_reset_token_is_invalid_please_check_it_again_and_reload_the_page":
    "Your password reset token is invalid, please check it again and reload the page",
  "users.confirm_new_password": "Confirm New Password",
  "users.please_input_confirm_new_password":
    "Please input Confirm New Password",
  "users.please_input_new_password": "Please input New Password",
  "users.status": "Status",
  "users.add_as_employee": "Add as Employee",
  "users.employee": "Employee",
  "users.email_is_not_registered_with_gajihub":
    "Email is not registered with GajiHub.",
  "users.please_fill_the_register_form": "Please fill the register form",
  "users.invalid_invitation_token": "Invalid invitation token",
  "users.your_invitation_token_is_invalid_please_check_it_again_and_reload_the_page":
    "Please check it again and reload the page",
  "users.you_are_invited_to_join": "You are invited to join",
  "users.do_you_agree_to_join": "Do You agree to join",
  "users.please_input_your_name": "Please input your name.",
  "users.phone_number": "Phone Number",
  "users.phone_number_is_required": "Phone Number is required",
  "users.no_phone_number_worng": "Phone Number worng",
  "users.phone_number_must_be_at_least_5_characters":
    "Phone Number must be at least 5 characters",
  "users.phone_number_cannot_be_longer_than_20_characters":
    "Phone Number cannot be longer than 20 characters",
  "users.please_input_your_phone": "Please input your phone.",
  "users.activate": "Activate",
  "users.waiting_for_confirmation": "Waiting for Confirmation",
  "users.resending_help":
    "To confirm, please open your email inbox, and click the link sent by Kledo.",
  "users.resending": "Resending",
  "users.success_resending": "Successfully Sending Invitations",
  "users.success_resending_desc":
    "Invitation successfully resent to email {{email}}. Please open your email inbox, and click on the link that has been sent by Kledo.",
  "users.you_have_registered_on_gajiHub_with_your_username":
    "You have registered on GajiHub with your username",
  "users.click_the_button_below_to_log_in_to_gajiHub":
    "Click the button below to log in to GajiHub",
  "users.info_is_only_has_role_employee":
    "You are logged in as an employee. To continue using the gajihub application, please select the following option",
  "users.login_to_the_ess_application": "Login to the ESS Application",

  please_input_the_name: "Please input the name!",
  please_input_the_message: "Please inpuut the message!",
  max_characters: "Max {{value}} char",
  min_characters: "Min {{value}} char",
  only_number_allowed: "Only number allowed",
  no_data: "No data",
  select_contact: "Select contact",
  send_wa_messages: "Send Whatsapp Messages",
  the_conversation_has_been_successfully_closed:
    "The conversation has been successfully closed",
  the_conversation_has_been_successfully_updated:
    "The detail conversation has been successfully updated",
  no_chat_yet: "No chat yet",
  please_start_chatting_first: "Please start chatting first",
  start_chat: "Start new chat",
  no_conversation_selected_yet: "No conversation selected yet",
  please_select_conversation_first: "Please select conversation first",
  please_select_contact: "Please select contact",
  please_select_template: "Please select template",
  to: "To",
  message: "Message",
  contact: "Contact",
  number: "Number",
  select_template: "Select template",
  message_content: "Message content",
  agent: "Agent",
  select_agent: "Select agent",
  phone_number: "Phone number",
  select_phone_number: "Select phone number",
  update_contact_success: "Update contact success",
  update_contact_error: "Update contact failed",
  change_contact: "Change Contact",
  company_name: "Company name",
  contact_name: "Contact name",
  contact_info: "Contact Info",
  please_input_the_number: "Please input handphone number",
  please_input_message: "Please input message",

  "companies.company_list": "Company List",
  "companies.add_company": "Add Company",
  "companies.created_on": "Created on ",
  "companies.as": "As",
  "companies.are_you_sure_to_delete_this_company":
    "Are You sure to delete this company?\nAfter deleted, the data cannot be returned",

  "profile.title": "My Profile",
  profile: "Profile",
  "profile.image_profile": "Profile Image",
  "profile.my_profile": "My Profile",
  "profile.old_password": "Old Password",
  "profile.please_input_the_old_password": "Please input the old password.",
  "profile.new_password": "New Password",
  "profile.please_input_the_new_password": "Please input the new password.",
  "profile.max_100_characters": "Max 100 characters.",
  "profile.confirm_new_password": "Confirm New Password",
  "profile.please_input_the_confirm_new_password":
    "Please input the confirm new password.",
  "profile.email_or_username": "Email / Username",
  "profile.please_input_the_email/username": "Please input the email/username.",
  "profile.the_input_is_not_valid-e-mail": "The input is not valid E-mail.",
  "profile.full_name": "Full Name",
  "profile.please_input_the_full_name": "Please input the full name.",
  "profile.only_alphanumeric_allowed": "Only alphanumeric allowed.",
  "profile.phone_number": "Phone Number",
  "profile.please_input_the_phone_number": "Please input the phone number.",
  "profile.max_20_characters": "Max 20 characters.",
  "profile.only_number_allowed": "Only number allowed.",
  "profile.user_profile_successfully_updated":
    "User profile successfully updated.",
  "profile.error_cannot_update_user_profile": "Cannot update user profile.",
  "profile.user_password_successfully_updated":
    "User password successfully updated.",
  "profile.error_cannot_update_user_password": "Cannot update user password.",
  "profile.change_password": "Change Password",
  "profile.two_passwords_that_you_enter_is_inconsistent_":
    "Two passwords that you enter is inconsistent.",
  "profile.password_atleast_8_characters_atleast_1_uppercase_and_atleast_1_digit":
    "Password atleast 8 characters, atleast 1 uppercase and atleast 1 digit.",
  "profile.password_atleast_6_characters": "Password atleast 6 characters.",
  "profile.logout_from_all_device": "Logout from all device",
  "profile.cannot_logout_from_all_device": "Cannot logout from all device",

  "error.an_error_happened": "An Error Happened",
  "error.failed_to_load_data_from_server": "Failed to load data from server!",
  "error.failed_to_delete_data_from_server":
    "Failed to delete data from server!",
  "error.failed_save_data_to_server": "Failed save data to server!",
  "error.max_characters": "Max {{value}} characters.",
  "error.min_characters": "Min {{value}} characters.",
  please_fill_one_of_filter_first: "Please fill one of filter first",

  "property.company": "Company",
  "property.company_details": "Company Details",
  "property.company_name": "Name",
  "property.email_address": "Email Address",
  "property.please_input_the_company_name": "Please input the company name.",
  "property.max_100_characters": "Max 100 characters.",
  "property.only_alphanumeric_allowed": "Only alphanumeric allowed.",
  "property.invalid_email_address_format": "Invalid email address format.",
  "property.phone_number": "Phone Number",
  "property.max_20_characters": "Max 20 characters.",
  "property.only_number_allowed": "Only number allowed.",
  "property.address": "Billing Address",
  "property.address_delivery": "Delivery Address",
  "property.country": "Country",
  "property.tax_number": "Tax Number",
  "property.please_select_the_country": "Please select the country.",
  "property.select_country": "Select country",
  "property.company_logo": "Company Logo",

  "property.file_uploaded_successfully": "file uploaded successfully.",
  "property.file_upload_failed": "file upload failed.",
  "property.you_can_only_upload_jpg_or_png_file_":
    "You can only upload JPG/PNG file.",
  "property.image_must_smaller_than": "Image must smaller than",
  "property.image_width_must_smaller_than": "Image width must smaller than",
  "property.image_height_must_smaller_than": "Image height must smaller than",
  "property.image_file_dimension_maximal": "Image file dimension maximal",
  "property.click_or_drag_file_to_this_area_to_upload":
    "Click or drag file to this area to upload",
  "property.preview": "Preview",
  "property.image_file_size_maximal": "Image file size maximal",
  settings: "Settings",
  "settings.company": "Company's data and logo",
  "settings.users": "Invite staff and colleagues to use Kledo",
  "settings.roles": "Manage users role",
  "settings.profile": "Manage profile and change password",
  "settings.billing": "Upgrade and renew plan",
  "settings.business_flow": "Manage your business flow",
  "settings.template": "Manage message template",
  "settings.apps": "Connect your Apps with CRM.id API",
  "settings.audit": "Watch data log",
  "settings.category": "Organize your conversation categories",
  company: "Company",
  billing: "Billing",
  businessflow: "Business Flow",
  template: "Template",
  tag: "Tag",
  select_tag: "Select tag",
  add_tag: "Add tag",
  email: "Email",
  create_success: "Successfully added {{value}}.",
  create_failed: "Failed to add {{value}}.",
  update_success: "Successfully updated {{value}}.",
  update_failed: "Failed to update {{value}}.",
  delete_success: "Successfully removed {{value}}.",
  delete_failed: "Failed to remove {{value}}.",
  tag_name: "Tag name",
  name: "Name",
  change_tag: "Change Tag",
  select_color: "Select color",
  contact_not_found: "Contact not found",

  a_new_version_is_available: "A new app update is available",
  reload_will_refresh_the_app_you_may_lose_the_progress_if_any:
    "Reload will refresh the app, you may lose the progress if any.",
  cancel_will_install_the_update_next_time_you_visit_the_app:
    "Cancel will install the update next time you visit the app.",
  file_uploaded_successfully: "File {{value}} uploaded successfully.",
  file_upload_failed: "File {{value}} upload failed.",

  "billing.title": "Billing",
  "billing.upgrade_title": "Upgrade Billing",
  "billing.balance": "Balance",
  "billing.topup_balance": "Top Up Balance",
  "billing.current_month": "Current Month",
  "billing.last_month": "Last Month",
  "billing.current_year": "Current Year",
  "billing.last_year": "Last Year",
  "billing.total": "Total",
  "billing.usage": "Usage",
  "billing.topup": "Top up",
  "billing.number_of_chats": "Number of Chats",
  "billing.payment_history": "Payment History",
  "billing.date": "Date",
  "billing.description": "Description",
  "billing.transaction": "Transaction",
  "billing.payment_confirmation": "Payment Confirmation",
  "billing.for_balance_topup":
    "For balance top-up, please proceed with the transfer to ",
  "billing.bank_account_number": "the following bank account number",
  "billing.after_transfer": "After making the transfer, please confirm",
  "billing.wa": "via WhatsApp at",
  template_select_type: "Select Type",
  template_select_status: "Select Status",
  template_select_show: "Select Show",
  template_all: "All {{value}}",
  template_marketing: "Marketing",
  template_utility: "Utility",
  template_authentication: "Authentication",
  template_approved: "Approved",
  template_pending: "Pending",
  template_rejected: "Rejected",
  template_show: "Show",
  template_hide: "Hide",
  template_name: "Name",
  template_type: "Type",
  template_status: "Status",
  template_update_success: "Template updated successfully.",
  template_update_error: "Template failed to updated.",
  template_create_success: "Template added successfully.",
  template_create_error: "Template failed to add.",
  template_category: "Category",
  template_sub_category:
    "Choose the category that best describes your message template.",
  template_sub_name: "Name your message template",
  template_please_input: "Name cannot be empty",
  template_please_input_content: "Content cannot be empty",
  template_content_placeholder: "Type your WhatsApp message template here...",
  template_characters: "Characters:",
  template_add_variable: "Add Variable",
  template_add_variable_empty: "Add Empty Value",
  template_preview: "Preview Template",
  template_variable_name: "Variable Name",
  template_example: "Example: Utility Template",
  template_content: "Content",
  template_marketing_sub:
    "Promotions or information about your business, products or services.",
  template_utility_sub:
    "Messages about specific transactions, accounts, orders, or customer requests.",
  template_authentication_sub:
    "One-time password or OTP used to authenticate transactions or logins.",
  template_add_button: "Add Template",
  template_show_success: "Template berhasil ditampilkan.",
  template_hide_success: "Template berhasil disembunyikan.",
  template_show_error: "Template gagal ditampilkan.",
  template_hide_error: "Template gagal disembunyikan.",
  template_move_success: "Template berhasil dipindahkan.",
  template_move_error: "Template gagal dipindahan.",

  roles: "Roles",
  add_role: "Add Role",
  edit_role: "Edit Role",
  "roles.search_by_role_name": "Search by role name",
  "approvals.and_number_others": "and {{value}} others",
  user: "User",
  "settings.set_users": "Set Users",
  "roles.select_role_to_delete": "Select Role to Delete",
  "roles.please_select_a_role": "Please select a role.",
  "roles.select_role": "Select role",
  "roles.successfully_deleted": "Successfully deleted.",
  "roles.error_cannot_delete": "Cannot delete",
  "roles.name": "Role name",
  "roles.successfully_added": "Successfully added.",
  "roles.error_cannot_add": "Cannot add",
  "roles.users_with_this_role": "Users with this role",
  "roles.click_here_to_set_users": "<t>Click here</t> to set users.",
  roles_successfully_updated: "Role successfully updated.",
  "roles.error_cannot_update_role": "Cannot update role.",
  roles_moved_successfully: "Role moved successfully.",
  "roles.error_cannot_move_the_channel": "Cannot move the channel.",
  "priceRule.active": "Active",
  "settings.set_roles": "Set Roles",
  "users.error_cannot_delete": "Cannot delete",
  "users.error_cannot_add": "Cannot add",
  "users.error_cannot_update": "Cannot update",
  "users.role": "Role in the company as",
  "users.click_here_to_set_roles": "<t>Click here</t> to set roles.",
  "users.error_cannot_update_user": "Cannot update user.",
  roles_not_found: "Role with id {{id}} not found",

  tags: "Tags",
  tag_contact: "Contact",
  create_tag_success: "Tag created",
  create_tag_failed: "Tag failed to create",
  update_tag_success: "Tag updated",
  update_tag_failed: "Tag failed to update",
  delete_tag_success: "Tag deleted",
  delete_tag_failed: "Tag failed to delete",
  "settings.tags": "Manage contact marker tags",

  "settings.channel": "Set up your channels",
  archive: "Archive",
  please_input_name: "Please input name",
  add_channel_message:
    "Hello CRM.id Great Team, I'm {{name}} from {{companyName}}, I want to add a channel, please help!",
  change_status_pending_channel:
    "Please call {{phoneNumber}} to activate the channel",
  "appSetting.apps": "Apps",
  "appSetting.date_created": "Date Created",
  "appSetting.app_name": "App Name",
  "appSetting.client_id": "Client ID",
  "appSetting.client_id_has_been_copied": "Client ID has been copied",
  "appSetting.secret_has_been_copied": "Secret has been copied",
  "appSetting.endpoint_has_been_copied": "API Endpoint URL has been copied",
  "appSetting.documentation_has_been_copied":
    "API Documentation has been copied",
  "appSetting.api_documentation_endpoint": "API Documentation Endpoint",
  "appSetting.please_input_name": "Please input app name",
  "appSetting.please_redirect_uri": "Please input redirect URI",
  "appSetting.please_valid_uri": "Please input valid URL",
  "appSetting.error_cannot_get": "Cannot get apps",
  "appSetting.error_cannot_create": "Cannot create apps",
  "appSetting.error_cannot_edit": "Cannot edit apps",
  "appSetting.error_cannot_delete": "Cannot delete apps",
  "appSetting.app_has_been_created_make_sure_save_secret":
    "New app has been created, please please save secret code below before going to another page.",
  "appSetting.secret_code_just_shown_once":
    "Secret code just shown once. Save this code, because after this you cannot see this secret code again.",
  "appSetting.integrate_your_app_with_kledo":
    "Integrate your application with Kledo",
  "appSetting.now_app_can_be_integrated_with_kledo":
    "Now your application, website, or software can be integrated with Kledo.",
  "appSetting.for_more_details_lets_see_the_video":
    "For more details, lets watch the video",
  "appSetting.watch_video": "Watch video",
  "breadcrumb.detail": "Detail",
  "table.lets_create_your_first_x": "Lets create your first {{name}}!",
  "table.data_empty": "Data Empty",
  "table.data_x_empty": "{{name}} Data Empty",
  "title.add_tag": "Add Tags",
  add_apps: "Add Apps",
  detail_apps: "Detail Apps",

  "settings.categories": "Set up your chat categories",
  "title.categories": "Categories",
  "button.addCategories": "Add Categories",
  confirm_delete_category: "Are you sure to delete this category?",
  delete_category: "Category has been deleted.",
  delete_category_failed: "Cannot delete category.",
  create_category: "Category created.",
  create_category_failed: "Cannot create category.",
  update_category: "Category edited.",
  update_category_failed: "Cannot edit category.",
  add_category: "Add Category",
  sub_category: "Sub Category from",
  select_category: "Select Category",
  archive_category: "Category archived.",
  archive_category_failed: "Cannot archive category.",
  unarchive_category: "Category unarchived.",
  unarchive_category_failed: "Cannot unarchive category.",
  move_category: "Category moved.",
  move_category_failed: "Cannot move category.",
  move_category_invalid: "Invalid category position.",
  categories: "Categories",

  menu_setting_company: "Company",
  menu_setting_billing: "Billing",
  menu_setting_businessflow: "Business Flow",
  menu_setting_setting_template: "Template",
  menu_setting_profile: "Profile",
  menu_setting_users: "Users",
  menu_setting_roles: "Roles",
  menu_setting_tags: "Tags",
  menu_setting_channel: "Channels",
  menu_setting_apps: "Open API",
  menu_setting_categories: "Categories",
  total_contact: "Total Contacts",
  new_contacts_today: "New Contacts Today",
  new_contacts_7_days: "New Contacts 7 Days",
  new_contacts_30_days: "New Contacts 30 Days",

  group: "Group",
  edit_group: "Edit Grup",
  add_group: "Add Grup",
  add_contact: "Add Contact",
  edit_contact: "Edit Contact",
  update_contact_group_success: "Contact group updated.",
  update_contact_group_failed: "Cannot update contact group.",
  create_contact_group_success: "Contact group created.",
  create_contact_group_failed: "Cannot create contact group.",
  please_input_the_unit_name: "Please input the group name.",
  only_alphanumeric_allowed: "Only alphanumeric allowed.",

  //contact
  show_photo: "Show Photo",
  hide_photo: "Hide Photo",
  photo: "Photo",
  contact_information: "Contact Information",
  contact_type: "Contact Type",
  please_select_a_contact_type_with_minimal:
    "Please select the type of contact, at least 1 type of contact.",
  please_select_a_group: "Please select group.",
  select_contact_type: "Select contact type",
  input_contact_name: "Please input the contact name.",
  salutation: "Salutation",
  select_salutation: "Select Salutation",
  phone: "Phone",
  input_phone: "Please input the phone number.",
  input_company: "Please input the company name.",
  fill_company_first: "Please fill in the company name first.",
  "contact_validation.name_warning_1":
    "Make sure the customer name is the real name.",
  "contact_validation.name_warning_2":
    "The customer name will be used in automatic reminders sent via WhatsApp.",
  "contact_validation.name_invalid_chars":
    "Name may only contain letters, spaces, periods, and apostrophes (').",
  "contact_validation.name_no_salutation":
    "Name must not start with a salutation/title (e.g. Ibu, Bapak, Pak, Bu, Kak, Sdr).",
  "contact_validation.name_not_all_lowercase":
    "Name must not be all lowercase.",
  "contact_validation.name_not_all_uppercase":
    "Name must not be all uppercase.",
  "contact_validation.company_invalid_chars":
    "Company name may only contain letters, numbers, spaces, and . - / | &.",
  "contact_validation.company_not_all_lowercase":
    "Company name must not be all lowercase.",
  "contact_validation.company_not_all_uppercase":
    "Company name must not be all uppercase.",
  "contact_validation.company_same_as_name":
    "Company name must not be the same as the contact name.",
  "contact_validation.company_warning":
    "Make sure the company name is correct.",
  "contact_validation.must_contain_letter": "Must contain at least one letter.",
  billing_address: "Billing Address",
  country: "Country",
  province: "Province",
  city: "City",
  select_country: "Please select country.",
  select_province: "Please select province.",
  select_city: "Please select city.",
  date_of_birth: "Date of Birth",
  contact_created: "Contact created",
  contact_created_failed: "Cannot create contact.",
  delete_photo_failed: "Cannot delete photo.",
  contact_deleted: "Contact has been deleted.",
  contact_deleted_failed: "Cannot delete contact.",
  contact_archive: "Contact has been archived.",
  contact_archive_failed: "Cannot archive contact.",
  contact_unarchive: "Contact has been unarchived.",
  contact_unarchive_failed: "Cannot unarchive contact.",
  confirm_delete_contact: "Are you sure to delete this contact?",
  confirm_archive_contact: "Are you sure to archive this contact?",
  confirm_unarchive_contact: "Are you sure to unarchive this contact?",
  contact_edited: "Contact edited.",
  contact_edited_failed: "Cannot edit contact.",
  button_prev: "Previous",
  button_next: "Next",
  tooltip_prev_calendar: "Previous calendar",
  tooltip_next_calendar: "Next calendar",
  contact_edit: "Edit Contact",
  contact_detail: "Detail Contact",
  table_show_data: "Show Data",
  all: "All",
  vendor: "Vendor",
  employee: "Employee",
  customer: "Customer",
  other: "Other",
  all_group: "All Group",
  without_archive: "Without archive",
  with_archive: "with archive",
  only_archive: "archive only",
  show_archive: "Show Archive",
  min_show_one_column: "Minimum show one column",
  mass_delete_info:
    "**Contact that have a history chat cannot be deleted, can only be archived",
  mass_delete: "Mass Delete",
  can_be_deleted: "Can be deleted",
  archived: "Archived",
  massDelete_are_you_sure:
    "Are you sure want to delete/archive {{value}} Contacts(s)?",
  data_irreversible: "Deleted data is irreversible.",
  massDelete_progress: "{{count}} out of {{total}} data has been deleted",
  massDelete_success: "Total {{count}} data has been deleted.",
  rows_selected: "rows selected",
  contact_per_group: "CONTACT PER GROUP",
  contact_per_province: "CONTACT PER PROVINCE",
  new_contact: "NEW CONTACT",
  contact_total: "TOTAL CONTACT",
  contact_group_deleted: "Contact group has been deleted.",
  contact_group_deleted_failed: "Cannot delete contact group.",
  remove_group: "Remove Group",
  announce_contact_group_delete:
    "Note: Only group that not assigned in contact could be deleted.",
  select_contact_group: "Please select contact group.",
  conversations: "Conversations",
  "chat-lines-count": "Chat Lines Count",
  the_latest_chat: "The Latest Chat",
  the_first_chat: "The First Chat",
  contacts: "Contacts",
  send_chat: "Send Chat",
  history_conversation: "History Conversation",
  "users.welcome_to_crm": "WELCOME TO CRM.id",
  "users.phone": "Phone",
  "users.yes": "Yes",
  "users.no": "No",
  "users.only_number_allowed": "Only number allowed.",
  "profile.password_atleast_8_characters": "Password atleast 8 characters.",
  "profile.password_pattern_minimum_1_capital_and_1_lowercase_letter":
    "Minimum 1 capital letter and 1 lowercase letter.",
  "profile.password_pattern_minimum_1_number": "Minimum 1 number.",

  "option.update_success": "Option updated",
  "option.update_failed": "Cannot update option",
  "option.conversation": "Conversation",
  "option.category": "Categories",
  "option.category_subtitle":
    "Conversations must include categories before closing.",
  "option.notes": "Notes",
  "option.notes_subtitle": "Conversations must include notes before closing.",

  "label.close_conversation": "Close Conversation",
  "label.detail_conversation": "Detail",
  "title.detail_conversation": "Detail Conversation",
  "title.save_conversation": "Save",
  "title.close_conversation":
    "Please complete the following data before closing the conversation :",
  "required.category": "Please select category.",
  "title.notes": "Notes",
  "placeholder.notes": "Please enter a note",

  "roles.please_input_the_role_name": "Please input the role name.",
  "roles.max_100_characters": "Max 100 characters.",
  "bots.chat_bot": "Chat Bot",
  "bots.chat_bot_flows": "Chat Bot Flows",
  "bots.manage": "Manage",

  blast_message: "Blast Message",
  "blast_message.column_name": "Name",
  "blast_message.column_number_recipients": "Number of Recipients",
  "blast_message.column_sent": "Sent",
  "blast_message.column_read": "Read",
  "blast_message.column_replied": "Replied",
  "blast_message.column_date": "Date",
  "blast_message.column_failed": "Failed",
  "blast_message.column_not_sent_yet": "Not sent yet",
  "blast_message.column_delivered": "Delivered",

  "blast_message.btn.add_contact": "Add Contact",
  "blast_message.btn.add_template": "Add Template",
  "blast_message.btn.import_contact": "Import Contact",

  "blast_message.text_add_contact_first":
    "Before you can send a blast, please add a contact list first.",
  "blast_message.text_add_template_first":
    "Before you can send a blast, please create a message template first.",

  blast_message_create: "Send Blast Message",
  "blast_message_create.message_template_cannot_be_empty":
    "Template Body must be filled in",

  "blast_message_create.tooltip_name":
    "The name will not be visible to the recipients; it can only be accessed by you and your team.",
  "blast_message_create.label_phone_number": "Phone Number",
  "blast_message_create.label_recipient": "Recipient",
  "blast_message_create.label_all_contacts": "All Contacts",
  "blast_message_create.label_contact_type": "Contact Type",
  "blast_message_create.label_contact_group": "Contact Group",
  "blast_message_create.label_per_contact": "Per Contact",
  "blast_message_create.label_contact_types":
    "Select the contact type to send the message to",
  "blast_message_create.label_contact_groups":
    "Select the contact group to send the message to",
  "blast_message_create.label_contacts":
    "Select the contact to send the message to",
  "blast_message_create.label_total_recipient": "Total Recipients",
  "blast_message_create.label_message_template": "Message Template",

  "blast_message_create.required_name": "Name is required",
  "blast_message_create.required_contact_types":
    "Contact type must be selected",
  "blast_message_create.required_contact_groups":
    "Contact group must be selected",
  "blast_message_create.required_contacts": "Contact must be selected",
  "blast_message_create.required_message_template": "Please select a template",

  "blast_message_create.message_successfully_created":
    "Blast Message successfully created.",
  "blast_message_create.btn_send_now": "Send Now",
  "blast_message_create.label_recipient_list": "Recipient Contact List",
  "blast_message_create.title_confirmation":
    "Are you sure you want to send this message to {{value}} contacts?",
  "blast_message_create.btn_yes_send_now": "Yes, Send Now",
  "blast_message_create.subtitle_confirmation":
    "This blast message delivery cannot be canceled. A fee will be charged per the number of message recipients.",
  type: "Type",
  new: "New",
  blast_message_detail: "Detail Blast Message",
  "blast_message_detail.send_time": "Send Time",
  "blast_message_detail.message_delivery_status": "Message delivery status",
  "settings.bots": "Set up chat bots for smooth conversations and preferences",
  "bots.select_channels": "Select Channels",
  "bots.please_select_channels": "Please select channels",
  "bots.please_input_response": "Please input response",
  "bots.keywords": "Keywords",
  "bots.press_enter_to_add_keyword": "Press Enter to add keyword",
  "bots.please_add_keyword": "Please add keyword",
  "bots.new": "New",
  "bots.reuse": "Reuse",
  "bots.please_select_user_input": "Please select user input",
  "bots.channels": "Channels",
  "bots.are_you_sure_want_to_publish": "Are you sure to publish?",
  "bots.are_you_sure_want_to_unpublish": "Are you sure to unpublish?",

  "settings.divisions": "Manage your divisions",

  "division.delete_success": "The division has been deleted",
  "division.delete_failed": "Cannot delete the division",
  "division.update_success": "The division has been updated",
  "division.update_failed": "Cannot update the division",
  "division.create_success": "The division has been created",
  "division.create_failed": "Cannot create the division",

  "division.add": "Add Division",
  "division.who_spv": "Who is the supervisor of this division?",
  "division.select_spv": "Please select supervisor",
  "division.who_agents": "Who are the agents of this division?",
  "division.select_agents": "Please select agents",
  "division.access_channel": "Which channels can this division access?",
  "division.select_channel": "Please select channel",

  "assign.switch_agent": "Switch Agent",
  "assign.select_transfer_agent": "Select an agent to transfer",
  "assign.select_transfer_agent_validate": "Please select an agent",
  "assign.select_transfer_agent_placeholder": "Select an agent",
  "assign.transfer_conversation": "Transfer Conversation",
  "assign.take_conversation_for_me": "Take the conversation for me",
  "assign.take_conversation_failed":
    "Failed to take the conversation, please try again.",

  "agent.name_agent": "Agent Name",
  "agent.max_conversation": "Max Conversation",
  "agent.duplicate_warning": "You cannot select an agent that already exists",
  "agent.success_create_agent_limit": "Agent chat limit successfully created",
  "agent.failed_create_agent_limit": "Agent chat limit failed to create",
  "agent.success_remove_agent_limit": "Agent chat limit successfully deleted",
  "agent.failed_remove_agent_limit": "Agent chat limit failed to delete",

  "option.assign_mode": "Agent Assign Mode",
  "option.assign_mode_desc": "Is the agent assign mode enabled?",
  "option.agents_can_take_over_conversations":
    "Agent Takeover for Unassigned Conversations",
  "option.agents_can_take_over_conversations_desc":
    "Enable this option to allow agents to take over conversations that have not been assigned to any specific agent",
  "option.agents_transfer_conversations":
    "Allow Agents to Transfer Conversation",
  "option.agents_transfer_conversations_desc":
    "Enable this option to allow agents to transfer ongoing conversations to another agent",
  "option.agents_automatic_assign":
    "Automatically Assign Conversations to Agent",
  "option.agents_automatic_assign_desc":
    "Enable this option to automatically assign incoming conversations to available agents",
  "option.agents_limit_conversation": "Limit Conversations Handled by Agents",
  "option.agents_limit_conversation_desc":
    "Enable this option to limit the number of active conversations each agent can handle simultaneously",
  "option.maximum_conversation_agent": "Set Maximum Conversations per Agent",
  "option.maximum_conversation_agent_desc":
    "Define the maximum number of active conversations an agent can handle at the same time",
  "option.maximum_conversation_per_agent":
    "Limit the Number of Conversations per Agent",
  "option.maximum_conversation_per_agent_desc":
    "Set a limit on the number of active conversations that each agent can handle to ensure effective workload management",
  "option.transfer_conversation_unanswered":
    "Transfer Conversations if Unanswered",
  "option.transfer_conversation_unanswered_desc":
    "Automatically transfer conversations to another agent if they remain unanswered for a specified number of minutes",
  "option.transfer_conversation_unanswered_time":
    "Set Time to Transfer Unanswered Conversations",
  "option.transfer_conversation_unanswered_time_desc":
    "Specify the number of minutes after which unanswered conversations will be automatically transferred to another agent",
  "option.notify_spv_if_unanswered":
    "Notify Supervisor if Conversation is Unanswered",
  "option.notify_spv_if_unanswered_desc":
    "Enable this option to send a notification to the supervisor if a conversation remains unanswered for a specified number of minutes",
  "option.set_time_notify_spv_if_unanswered":
    "Set Time to Notify Supervisor for Unanswered Conversations",
  "option.set_time_notify_spv_if_unanswered_desc":
    "Define the number of minutes after which a notification will be sent to the supervisor if a conversation remains unanswered",

  "lead-and-task-management": "Lead & Task Management",
  "task.task_type": "Task Type",
  "task.task_stages": "Task Stages",
  "task.task_status": "Task Status",
  "task.company": "Company",
  "task.plan": "Plan",
  "task.stage": "Stage",
  "task.status": "Status",
  "task.deadline": "Deadline",
  "task.report": "Report",
  "task.action": "Action",
  "task.send": "Send",
  "task.send_and_complete": "Send & Set Completed",
  "task.completed": "Set Completed",
  "task.stop": "Stop",
  "task.assignAt": "Assigned At",
  "task.maxResponseAt": "Max Response At",
  "task.release": "Release",
  "task.startResponse": "Start Response",
  "task.completedAt": "Completed At",
  "task.createdAt": "Created At",
  "task.detail": "Detail",
  "task.stop_reason": "Reason",

  "task.admin.all": "All Admins",
  "task.stages.all": "All Stages",
  "task.status.all": "All Status",

  "task.filter_title_task_type": "Task Type",
  "task.filter_title_admin": "Admin",
  "task.filter_title_stage": "Task Stages",
  "task.filter_title_status": "Task Status",

  "task.success_send_wa": "Message sent successfully",
  "task.failed_send_wa": "Message failed to send",

  "task.required_select_phone_number": "Please select phone number",
  "task.select_phone_number": "Select phone number",

  "task.noHP": "No HP",
  "task.noHP.placeholder": "Input no HP",
  "task.required_noHP": "Please input no HP",

  "task.success_set_complete": "Task successfully completed",
  "task.failed_set_complete": "Task cannot be completed",

  "task.required_report": "Please input report",
  "task.required_report.placeholder": "Input report . . .",

  "task.success_set_stop": "Task successfully stopped",
  "task.failed_set_stop": "Task cannot be stopped",

  "task.required_reason": "Please select reason",
  "task.required_reason.placeholder": "Select reason",

  "permission.tasks": "Tasks",
  "permission.task_list": "Task List",
  "permission.task_list_other": "Task List Owned by Other Admins",
  "permission.setting_chatbots": "Chat Bots",

  "division.select_division": "Select agent division",
  "division.select_division_required": "Please select agent division",
  "division.select_placeholder": "Agent Division",

  "division.edit": "Edit Division",
  "division.can_receive_messages": "Can this division receive messages?",
  "division.can_receive_messages_title": "Receive Messages",
  "division.title_priority": "Division Priority",

  "division.success_create": "Division priority successfully created",
  "division.failed_create": "Cannot create division priority",
  "division.add_division_title": "Add Division Priority",
  "division.name": "Division Name",
  "division.success_remove": "Division priority removed successfully",
  "division.failed_remove": "Failed to remove division priority",
  "division.success_update": "Division priority updated successfully",
  "division.failed_update": "Failed to update division priority",

  reports: "Reports",
  "online-duration": "Online Duration",
  "team-response-time": "Team Response Time",
  "individual-response-time": "Individual Response Time",
  "auto-transfer-conversation": "Auto Transfer Conversation",
  "reports.channel": "Channel",
  "reports.channel_all": "All Channel",
  divisions: "Divisions",
  "reports.division_all": "All Division",
  "reports.agent": "Agent",
  "reports.agent_all": "All Agent",
  "reports.sender": "Sender",
  "reports.sender_all": "All Sender",
  "reports.customer": "Customer",

  "reports.daily": "Daily",
  "reports.hourly": "Hourly",
  "reports.monthly": "Monthly",
  "reports.hour": "Hour",
  "reports.minute": "Minute",
  "reports.seconds": "Seconds",
  "reports.times": "Times",

  "link.show_more": "Show more",
  "link.show_less": "Show less",

  "individual-response-time_detail": "Detail Individual Response Time",
  "reports.detail_message": "Message Detail",
  "reports.detail_response_time": "Response Time",
  "reports.total_user": "Total Users",
  "reports.total_conversation": "Total Conversations",
  "reports.total_auto_transfer": "Total Auto Assign",
  "reports.average_response_time": "Average Response Time",
  "businessflow.agent_auto_offline": "Agent Auto Offline",
  "businessflow.agent_auto_offline_desc":
    "Enable this mode to automatically change the agent's status to offline after a certain period of time",
  "businessflow.wa_last_active_to_auto_offline":
    "Set Idle Time Limit for Auto Offline",
  "businessflow.wa_last_active_to_auto_offline_desc":
    "Set the idle time limit in minutes before the agent's status is automatically changed to offline",
  "businessflow.activity": "Activity",

  "faqs.whats_your_question": "What's your Question?",
  "faqs.most_popular": "Most Popular",
  "faqs.most_help": "Most Help",
  "faqs.search_result": 'Search result "{{value}}"',
  "faqs.title_by_category": 'By "{{value}}" Category',
  "faqs.title_by_tag": 'By "{{value}}" Tag',
  "faqs.was_this_answer_helpful": "Was this answer helpful?",
  "faqs.last_update": "Last Update",
  "faqs.copy_raw_text": "FAQ copied successfully",
  "faqs.category": "Category",
  faqs: "FAQ",
  "faqs.detail": "Detail FAQ",
  "property.file_size_maximal": "File size maximal",
  "property.file_maximal": "Maximum {{value}} uploaded files",
  load_more_messages: "Load More Messages",
  "detail_response_time.redirect": "Redirect",

  meeting_schedule: "Meeting Schedule",
  meeting_management: "Meeting Management",
  "meeting-schedule": "Meeting Schedule",
  "meeting-management": "Meeting Management",
  "settings.meeting_schedule": "Adjust the meeting scheduling settings",

  "meeting_schedule.workday": "Workday",
  "meeting_schedule.dayoff": "Day Off",
  "meeting_schedule.user": "User",
  "meeting_schedule.user_schedule": "User Schedule",
  "meeting_schedule.user_schedule_desc":
    "Determine which admins can have schedules",
  "meeting_schedule.group_admin": "Group Admin",
  "meeting_schedule.admin_add": "Add Admin",
  "meeting_schedule.admin_edit": "Edit Admin",
  "meeting_schedule.cannot_select_past_time_slots": "Cannot select past time",

  "meeting_schedule.success_add_admin": "Admin Successfully Added",
  "meeting_schedule.success_edit_admin": "Admin Successfully Edited",
  "meeting_schedule.success_delete_admin": "Admin Successfully Deleted",

  "meeting_schedule.select_admin": "Select Admin",
  "meeting_schedule.select_admin_required": "Admin is required",
  "meeting_schedule.select_group": "Select Group",
  "meeting_schedule.select_group_required": "Grup admin is required",

  "meeting_schedule.group_admin_add": "Add Group Admin",
  "meeting_schedule.group_admin_edit": "Edit Group Admin",
  "meeting_schedule.group_channel": "Channel",

  "meeting_schedule.success_add_admin_group": "Group Admin Successfully Added",
  "meeting_schedule.success_edit_admin_group":
    "Group Admin Successfully Edited",
  "meeting_schedule.success_delete_admin_group":
    "Group Admin Successfully Deleted",

  "meeting_schedule.input_name": "e.g., Marketing Team",
  "meeting_schedule.input_color": "Color",
  "meeting_schedule.name_required": "Name is required",
  "meeting_schedule.color_required": "Color is required",
  "meeting_schedule.auto_select_admin": "Auto Assign Admin",

  "meeting_schedule.data_add": "Data Successfully Saved",
  "meeting_schedule.workday_title":
    "Set the Work Days and Hours for the Entire Team",
  "meeting_schedule.workday_description":
    "Specify the work days and work hours for the entire team.",

  "meeting_schedule.from_required": "From field is required",
  "meeting_schedule.to_required": "To field is required",
  "meeting_schedule.both_required": "Both From field and To field are required",
  "meeting_schedule.time_invalid": "Time is invalid",
  "meeting_schedule.time_overlap": "Time Overlaps with Existing Time",
  "meeting_schedule.from": "From",
  "meeting_schedule.to": "To",
  "meeting_schedule.add_field": "Add Field",

  "meeting_schedule.dayoff_success_delete":
    "Day Off has been successfully deleted",
  "meeting_schedule.dayoff_description":
    "Set the day off that will be applied to all admins",
  "meeting_schedule.add_dayoff": "Add Day Off",

  "meeting_schedule.dayoff_success_add": "Day off successfully added",
  "meeting_schedule.dayoff_date_required": "Date is required",
  "meeting_schedule.dayoff_name_required": "Name is required",
  "meeting_schedule.dayoff_name_placeholder": "e.g., New Year's Day Off",

  "meeting_management.calendar": "Calendar",
  "meeting_management.daily": "Daily",
  "meeting_management.tooltip_prev_month": "Previous month",
  "meeting_management.tooltip_next_month": "Next month",
  "meeting_management.timeline_no_group_for_admin":
    "This admin has no admin group available to create a schedule.",
  "meeting_management.all_schedule": "All Schedule",
  "meeting_management.no_schedule": "No schedules are available to display.",
  "meeting_management.no_schedule_hint": "Add an agent to the schedule first.",
  "meeting_management.add_agent": "Add Agent",
  "meeting_management.created_by": "Created By",
  "meeting_management.search_placeholder": "Search agent, contact, company...",
  "meeting_management.export_xls": "Export XLS",
  "meeting_management.schedule_meeting": "Schedule a Meeting",
  "meeting_management.contact_schedule_list": "Meeting Schedules",
  "meeting_management.no_schedule_yet": "No meeting schedules yet",
  "meeting_management.status": "Status",
  "meeting_management.all_statuses": "All Statuses",
  "meeting_management.last_template_messages": "Template Message History",
  "meeting_management.no_template_messages": "No template messages yet.",
  "meeting_management.setting_workday": "Set Work Days",
  "meeting_management.add_schedule": "Add Schedule",

  "meeting_management.admin": "Admin",
  "meeting_management.all_admins": "All Admins",
  "meeting_management.all_groups": "All Groups",
  "meeting_management.success_delete_schedule": "Schedule successfully deleted",
  "meeting_management.description": "Description",
  "meeting_management.meeting_report": "Meeting Outcome",
  "meeting_management.tags": "Tags",
  "meeting_management.add_tags": "Select or add tags",
  "meeting_management.all_tags": "All Tags",
  "meeting_management.tags_update_failed": "Failed to update tags",
  "meeting_management.note_updated": "Description updated successfully",
  "meeting_management.note_update_failed":
    "Could not update description. Please try again.",
  "meeting_management.title_delete_schedule": "Delete Schedule",
  "meeting_management.title_delete_schedule_desc":
    "Are you sure you want to delete the schedule?",
  "meeting_management.edit_schedule": "Edit Schedule",
  "meeting_management.set_unavailable": "Set Unavailable",
  "meeting_management.set_unavailable_desc":
    "Are you sure you want to set it as unavailable for {{value}}?",
  "meeting_management.set_available": "Set Available",
  "meeting_management.set_available_desc":
    "Are you sure you want to set it as available to {{value}}?",
  "meeting_management.at": "At",
  "meeting_management.schedule": "Schedule",
  "meeting_management.schedule_note": "Note",
  "meeting_management.schedule_status": "Status",
  "meeting_management.schedule_slot_available": "Available",
  "meeting_management.schedule_slot_unavailable": "Unavailable",
  "meeting_management.note_empty_hint": "Click to add a note",
  "meeting_management.status_updated": "Status updated successfully",
  "meeting_management.status_update_failed":
    "Could not update status. Please try again.",
  "meeting_management.send_reminder": "Send reminder",
  "meeting_management.reminder_sent": "Reminder sent",
  "meeting_management.reminder_send_failed": "Failed to send reminder",
  "meeting_management.reminder_no_zoom_templates":
    'No templates with "zoom" in the title for this WhatsApp number',
  "meeting_management.reminder_missing_phone_number":
    "WhatsApp number is missing from schedule detail",
  "meeting_management.reminder_from_channel": "From: {{channel}}",
  "meeting_management.reminder_column": "Reminder",
  "meeting_management.reminder_button": "Reminder",
  "meeting_management.last_modified_by":
    "Last modified by {{name}} at {{time}}",
  "meeting_management.view_reminders": "View reminders",
  "meeting_management.reminder_list_title": "Reminder List",
  "meeting_management.reminder_message": "Message",
  "meeting_management.reminder_send_time": "Send Time",
  "meeting_management.reminder_status": "Status",
  "meeting_management.reminder_load_failed": "Failed to load reminder list.",
  "meeting_management.reminder_morning_skipped":
    "The morning-of reminder is not sent because the meeting is scheduled before 11 AM.",
  "meeting_management.change_log": "Change Log",
  "meeting_management.reminder_detail_load_error":
    "Could not load schedule detail. Close and try again.",
  "meeting_management.detil": "Detail",
  "meeting_management.calendar_tooltip_no_booking":
    "This slot is available with no booking.",

  "audit.by": "by",
  "audit.title": "Audit",
  "meeting_schedule.select_admin_placeholder": "Select Admin",
  "meeting_schedule.admin_no_group": "No group",
  "meeting_schedule.not_available": "Not available",

  "meeting_reminder.title": "Meeting Reminder",
  "meeting_reminder.with": "with",
  "meeting_reminder.countdown_suffix": "remaining",
  "meeting_reminder.soon": "Starting soon",
  "meeting_reminder.now": "In progress",
  "meeting_reminder.hour": "hr",
  "meeting_reminder.minute": "min",
  "meeting_reminder.second": "sec",
  "meeting_finished.title": "Meeting Finished",
  "meeting_finished.intro": "The following meeting has finished",
  "meeting_finished.intro_sub":
    "Please update the meeting status & outcome below.",
  "meeting_finished.status_question": "What is the meeting status?",
  "meeting_finished.status_placeholder": "Select status",
  "meeting_finished.report_question": "What was the outcome of the meeting?",
  "meeting_finished.report_placeholder": "Write the meeting outcome...",
  "meeting_finished.report_min": "Minimum {{min}} characters",
  "meeting_finished.save": "Save",
  "meeting_finished.reschedule": "Reschedule",
  "meeting_finished.saved": "Meeting status saved successfully",
  "meeting_finished.save_failed": "Failed to save meeting status",
  "meeting_finished.load_failed": "Failed to load meeting detail",
  "meeting_finished.send_report_to_adminhebat": "Send report to AdminHebat",
  "meeting_finished.select_app": "Select app",
  "meeting_finished.select_company": "Select company",
  "meeting_finished.company_other": "Others",
  "meeting_finished.loading_recommendations": "Loading recommendations...",
  "meeting_finished.type_to_search": "Type to search companies...",
  "meeting_finished.back_to_recommendations": "← Back to recommendations",
  "meeting_finished.select_company_required":
    "Select a company first to send the report.",

  "meeting_report_wa.modal_title": "Send Summary to Customer",
  "meeting_report_wa.title": "WhatsApp message preview",
  "meeting_report_wa.desc":
    "Meeting points that will be sent to the customer. Click text to edit.",
  "meeting_report_wa.drafting": "Composing summary...",
  "meeting_report_wa.draft_failed": "Failed to create draft, please try again.",
  "meeting_report_wa.retry": "Try again",
  "meeting_report_wa.edit_point_hint": "Click to fill this point...",
  "meeting_report_wa.point_aria": "Point {{number}}",
  "meeting_report_wa.points_label": "Discussion points",
  "meeting_report_wa.points_limit":
    '{{max}} points available. Points left empty are sent as "-".',
  "meeting_report_wa.length_counter": "{{length}} / {{max}} characters",
  "meeting_report_wa.too_long": "Message is too long, shorten the points.",
  "meeting_report_wa.greeting_disclaimer":
    "The greeting adjusts to the time the message is sent.",
  "meeting_report_wa.send": "Send to customer",
  "meeting_report_wa.sent":
    "The summary is being sent to the customer via WhatsApp.",
  "meeting_report_wa.send_failed":
    "Failed to send the summary to the customer.",

  "meeting_schedule.select_group_placeholder": "Select Admin Group",

  "meeting_schedule.title_first_step":
    "What group do you want to schedule a meeting for?",
  "meeting_schedule.auto_assign_admin": "Auto-assign admin",
  "meeting_schedule.admin_no_group_message":
    "This agent has no group, please update this agent to have a group",
  "meeting_schedule.title_second_step": "Select a scheduled admin!",
  "meeting_schedule.previous": "Back",
  "meeting_schedule.next": "Next",
  "meeting_schedule.back": "Back",
  "meeting_schedule.auto": "Auto",
  "meeting_schedule.auto_desc": "Let the system pick the best agent",
  "meeting_schedule.when_question": "When is the meeting scheduled?",
  "meeting_schedule.pick_time": "What time?",
  "meeting_schedule.today": "Today",
  "meeting_schedule.tomorrow": "Tomorrow",
  "meeting_schedule.day2": "The day after tomorrow",
  "meeting_schedule.day3": "In 3 days",
  "meeting_schedule.pick_date": "Pick a date",
  "meeting_schedule.in_15_min": "In 15 minutes",
  "meeting_schedule.hour_label": "{{hour}}:00",
  "meeting_schedule.other_time": "Other time",
  "meeting_schedule.duration_question": "How long is the meeting?",
  "meeting_schedule.dur_1h": "1 hour",
  "meeting_schedule.dur_minutes": "{{m}} minutes",
  "meeting_schedule.other_duration": "Other",
  "meeting_schedule.hours": "h",
  "meeting_schedule.minutes": "m",
  "meeting_schedule.auto_slots_full":
    "All slots for {{date}} {{time}} are full, please pick the nearest available time:",
  "meeting_schedule.auto_no_slots": "No available slots.",
  "meeting_schedule.no_agent_available": "No agent available for this slot.",
  "meeting_schedule.auto_check_failed": "Failed to check availability.",
  "meeting_schedule.auto_agent_selected":
    "The system automatically selected <bold>{{name}}</bold> for this meeting.",
  "meeting_schedule.auto_view_reason": "View reasoning",
  "meeting_schedule.auto_reason_title": "Agent selection reasoning",
  "meeting_schedule.auto_reason_desc":
    "The agent is chosen by the highest deficit (quota − actual) among those available for this slot, based on working hours over the last 30 days.",
  "meeting_schedule.auto_picked": "picked",
  "meeting_schedule.auto_col_agent": "Agent",
  "meeting_schedule.agent_col_date": "Date",
  "meeting_schedule.agent_schedules_title": "{{name}}'s schedules",
  "meeting_schedule.wa_preview_title": "WhatsApp message preview",
  "meeting_schedule.wa_preview_desc":
    "This message is sent automatically to the customer when the schedule is created.",
  "meeting_schedule.notif_created": "Meeting Scheduled",
  "meeting_schedule.notif_rescheduled": "Meeting Rescheduled",
  "meeting_schedule.notif_contact_changed": "Meeting Contact Changed",
  "meeting_schedule.notif_status_changed": "Meeting Status Changed",
  "meeting_schedule.notif_status_new": "Meeting Scheduled",
  "meeting_schedule.notif_status_confirmed": "Meeting Confirmed",
  "meeting_schedule.notif_status_done": "Meeting Completed",
  "meeting_schedule.notif_status_cancelled": "Meeting Cancelled",
  "meeting_schedule.notif_status_no_show": "Meeting No-Show",
  "meeting_schedule.notif_status_zoom": "Zoom Offered",
  "meeting_schedule.notif_status_attend": "Attendance Confirmed",
  "meeting_schedule.notif_report_updated": "Meeting Report",
  "meeting_schedule.notif_deleted": "Meeting Deleted",
  "meeting_schedule.notif_view": "View",
  "meeting_schedule.agent_schedules_on_date_title":
    "{{name}}'s schedules — {{date}}",
  "meeting_schedule.agent_schedules_total": "Total: {{count}} schedules",
  "meeting_schedule.auto_col_priority": "Priority",
  "meeting_schedule.auto_col_workhours": "Work Hours",
  "meeting_schedule.auto_workhours": "{{h}}h {{m}}m",
  "meeting_schedule.auto_workhours_h": "{{h}}h",
  "meeting_schedule.auto_col_quota": "Quota",
  "meeting_schedule.auto_col_actual": "Actual",
  "meeting_schedule.auto_col_deficit": "Deficit",
  "meeting_schedule.auto_col_available": "Available",
  "meeting_schedule.auto_legend_quota":
    "Target number of meetings for the agent based on working hours in the period.",
  "meeting_schedule.auto_legend_actual":
    "Number of meetings the agent has already handled in the period.",
  "meeting_schedule.auto_legend_deficit":
    "Quota − Actual. Higher means further below target, so higher priority.",
  "meeting_schedule.auto_legend_available":
    "Whether the agent is free (no conflicting schedule) at the requested time slot.",
  "meeting_schedule.auto_total_meetings": "Total meetings",
  "meeting_schedule.auto_total_work": "Total work hours",
  "meeting_schedule.title_third_step":
    "What day and time will it be scheduled?",
  "meeting_schedule.tab_third_step_calendar": "Calendar",
  "meeting_schedule.tab_third_step_custom": "Custom",
  "meeting_schedule.no_hours": "No hours available, please select another date",
  "meeting_schedule.title_fourth_step": "Enter the schedule for ",
  "meeting_schedule.at": "at",
  "meeting_schedule.description_placeholder": "Enter a description",
  "meeting_schedule.description_required":
    "Please enter a description for the meeting",

  "meeting_schedule.set_unavailable_desc1":
    "Do you want to set it not available to {{value}} or all admins?",
  "meeting_schedule.all_admins": "All Admins",
  "meeting_management.set_available_desc1":
    "Do you want to set available to {{value}} or all admins?",

  "meeting_schedule.set_available_all_title": "Set Available All Time",
  "meeting_schedule.set_unavailable_all_title": "Set Unavailable All Time",

  "meeting_management.set_available_desc2":
    "Do you want to set available all time to {{value}} or all admins?",
  "meeting_management.set_available_desc3":
    "Are you sure you want to set it as available all time to {{value}}?",

  "meeting_management.set_unavailable_desc2":
    "Do you want to set unavailable all time to {{value}} or all admins?",
  "meeting_management.set_unavailable_desc3":
    "Are you sure you want to set it as unavailable all time to {{value}}?",
  "meeting_management.set_unavailable_modal_title":
    "Set unavailable for {{value}}",
  "meeting_management.set_unavailable_note_placeholder": "Enter note",
  "help.title": "Help",
  "help.title_detail": "Detail Help",

  "faqsUser.title": "FAQ",
  "faqsUser.category_name": "Category Name",
  "faqsUser.category": "Category",
  "faqsUser.category_name_required": "Please input category name",
  "faqsUser.category_name_placeholder": "Input category name",
  "faqsUser.question": "Question",
  "faqsUser.question_required": "Please input question",
  "faqsUser.question_placeholder": "Input question",
  "faqsUser.answer": "Answer",
  "faqsUser.answer_required": "Please input answer",
  "faqsUser.answer_placeholder": "Input answer",
  "faqsUser.add_tag_faq": "Add FAQ Tag",
  "faqsUser.labelsubcategory":
    "Create a Sub Category under the {{value}} Category",
  "faqsUser.labelsubcategory_required": "Please input Sub Category name",
  "faqsUser.labelsubcategory_placeholder": "Input Sub Category name",
  "faqsUser.success_update_faq_category": "FAQ Category successfully updated",
  "faqsUser.error_update_faq_category": "Failed to update FAQ Category",
  "faqsUser.success_create_faq_category": "FAQ Category successfully created",
  "faqsUser.error_create_faq_category": "Failed to create FAQ Category",
  "faqsUser.success_delete_faq_category": "FAQ Category successfully deleted",
  "faqsUser.error_delete_faq_category": "Failed to delete FAQ Category",

  "faqsUser.success_update_faq_user": "FAQ User successfully updated",
  "faqsUser.success_create_faq_user": "FAQ User successfully created",
  "faqsUser.success_delete_faq_user": "FAQ User successfully deleted",
  "faqsUser.error_update_faq_user": "Failed to update FAQ User",
  "faqsUser.error_create_faq_user": "Failed to create FAQ User",
  "faqsUser.error_delete_faq_user": "Failed to delete FAQ User",
  "faqsUser.create_faq": "Create FAQ User",
  "faqsUser.update_faq": "Update FAQ User",

  "faqsUser.success_update_faq_subcategory":
    "FAQ Sub Category successfully updated",
  "faqsUser.error_update_faq_subcategory": "Failed to update FAQ Sub Category",
  "faqsUser.success_create_faq_subcategory":
    "FAQ Sub Category successfully created",
  "faqsUser.error_create_faq_subcategory": "Failed to create FAQ Sub Category",
  "faqsUser.success_delete_faq_subcategory":
    "FAQ Sub Category successfully deleted",
  "faqsUser.error_delete_faq_subcategory": "Failed to delete FAQ Sub Category",
  "faqsUser.create_subcategory": "Add Sub Category",
  "faqsUser.update_subcategory": "Update Sub Category",

  "faqsUser.create_category": "Add Category",
  "faqsUser.update_category": "Update Category",

  "faqsUser.success_create_tag_faq": "Tag FAQ successfully created",
  "faqsUser.error_create_tag_faq": "Failed to create Tag FAQ",
  "faqsUser.add_tag_faq_user": "Add Tag FAQ User",
  "faqsUser.required_tag_name": "Please input tag name",
  "faqsUser.placeholder_tag_name": "Input tag name",

  "faqsUser.select_tag_faq": "Select Tag FAQ",
  "faqsUser.faq_title": "FAQ Title",
  "faqsUser.faq_created_at": "Created At",
  "faqsUser.faq_updated_at": "Updated At",
  "faqsUser.faqUser_title_add": "Add FAQ",
  "faqsUser.faqUser_title_edit": "Edit FAQ",

  "faqsUser.all_channel": "All Channel",
  "faqsUser.add_sub_category": "Add Sub Category",
  "faqsUser.edit": "Edit",
  "faqsUser.load_more": "Load More",

  "faqsUser.please_select_sub_category": "Please select sub category to show",

  "faqsUser.label_channel": "Channel",
  "faqsUser.label_channel_required": "Please select at least 1 channel",
  add: "Add",
  edit: "Edit",
  delete: "Delete",
  cancel: "Cancel",
  save: "Save",
  close: "Close",
  channels: "Channels",
  apps: "API Key",
  detail: "Detail",
  create: "Create",

  "option.user_rating": "Rating User",
  "option.user_rating_subtitle":
    "Send a message to ask the user to provide a rating at the end of each conversation.",
  "statistics-user-ratings": "User Ratings Statistics",
  "list-of-user-ratings": "List of User Ratings",
  "userRating.average": "Average Rating",
  "userRating.total": "Total Rating",

  "reports.message": "Message",
  "reports.with_message_all": "All",
  "reports.with_message": "With Message",
  "reports.without_message": "Without Message",

  "reports.comment": "Comment",
  "reports.all": "All",
  "reports.with_comment": "With Comment",
  "reports.without_comment": "Without Comment",

  "reports.rating": "Rating",
  "reports.rating_value_all": "All Rating",
  "report.show_chat": "View Chat",
  "meeting_schedule.no_schedule_weekend":
    "No schedule available for the weekend",
  "meeting_schedule.configure_workday":
    "Please configure work days in settings > meeting schedule,",
  "meeting_schedule.click_here": "Click here",
  "meeting_schedule.successfully_save_schedule": "Successfully saved schedule",
  "meeting_schedule.successfully_edit_schedule": "Successfully edited schedule",

  "permission.setting_meeting_schedule": "Meeting Schedule",
  "permission.meeting_schedule": "Meeting Management",
  "permission.meeting_schedule_calendar": "Meeting Calendar",
  "permission.meeting_schedule_all": "All Meeting Schedules",
  "permission.meeting_schedule_other_admin_access":
    "View Other Admins' Schedules",

  "meeting_schedule.available_time": "Waktu yang tersedia",
  "meeting_schedule.available_time_pick": "Pilih waktu yang tersedia",
  edit_category: "Edit Category",

  tag_contact_success_edit: "Tag successfully saved to contact",
  help: "Help",

  "faqsUser.searchResult": "Search Result",
  bots: "Chat Bot",
  audit: "Audit",
  "meeting_schedule.success_unavailable_all":
    "Successfully set all times to unavailable",
  "meeting_schedule.success_available_all":
    "Successfully set all times to available",
  "meeting_schedule.success_unavailable":
    "Successfully set times to unavailable",
  "meeting_schedule.success_available": "Successfully set times to available",

  otp_verification: "OTP Verification",
  otp_info:
    "We detected that you are trying to log in from a different device. For security purposes, please enter the OTP code",
  otp_needHelp: "Need help?",
  otp_contactUs: "Contact Us",
  otp_success_resend: "OTP code has been resent to email {{value}}.",
  otp_required: "OTP code is required.",
  otp_length: "OTP code must be 6 characters.",
  otp_send_email: "OTP code has been sent to email",
  otp_recheck: "Check your email and enter the code to complete the login.",
  otp_button_verif: "Verify",
  otp_button_cancel: "Cancel",
  otp_not_received: "Haven't received the OTP code?",
  otp_resend: "Resend code",

  "chatbot.success_update_flow": "Node updated successfully",
  "chatbot.error_update_flow": "Node update failed",
  "chatbot.success_update": "Bot updated successfully",
  "chatbot.error_update": "Bot update failed",
  "chatbot.success_update_publish": "Status publish updated successfully",
  "chatbot.error_update_publish": "Status publish update failed",

  "help.placeholder_search": "What's your Question?",
  otp_verification_change_email: "Change Email Verification",
  otp_needHelp_email: "Need help?",
  otp_verification_change_email_info:
    "You are trying to change your login email to:",
  otp_verification_change_email_description:
    "For the security of your account, we have sent OTP codes to both your old and new email addresses. Please enter both OTP codes below to complete the email change process.",
  "quality-assurance": "Quality Assurance",
  "quality-assurance-menu": "Quality Assurance",
  "data-quality-assurance": "Quality Assurance Data",
  "statistics-quality-assurance": "Quality Assurance Statistics",
  "chat-volume-statistics": "Chat volume statistics per agent",
  "chat-volume-statistics-daily": "Daily chat volume statistics",
  "reports.agent_num_char_count": "Volume",
  "reports.chat_statistics_line": "Line",

  "settings-quality-assurance": "Quality Assurance Categories",
  title: "Title",
  description: "Description",
  weight: "Weight",

  "reports.reviewer": "Reviewer",
  "reports.reviewer_all": "All Reviewer",

  "reports.qa_settings_desc":
    "Set the categories and weights of the assessment",

  "reports.total_score": "Total Score",
  "reports.chat": "Chat",
  "reports.review": "Review",

  "reportsQA.success_update_qa_category":
    "Quality Assurance category successfully updated",
  "reportsQA.success_update_qa_category_status":
    "Quality Assurance category status successfully updated",
  "reportsQA.success_create_qa_category":
    "Quality Assurance category successfully created",
  "reportsQA.success_delete_qa_category":
    "Quality Assurance category successfully deleted",
  "reportsQA.success_move_qa_category":
    "Quality Assurance category position successfully updated",

  "reportsQA.add_category_qa_title": "Add Quality Assurance Category",
  "reportsQA.edit_category_qa_title": "Edit Quality Assurance Category",
  "reportsQA.required_title": "Title is required",
  "reportsQA.required_description": "Description is required",

  "reportsQA.placeholder_title": "e.g., Customer Service Skills",
  "reportsQA.placeholder_description": "Enter description",
  "reportsQA.weight_percentage": "Weight (in percent)",
  "reportsQA.required_weight_percentage": "Weight is required",
  "reportsQA.weight_percentage_exceed": "Total weight must not exceed {{max}}%",
  "reportsQA.weight_percentage_must_positive": "Weight must be positive",
  "reportsQA.tooltip_max_weight_percentage": "Total maximum weight is {{max}}%",
  "reportsQA.btn_max": "Max",
  "reportsQA.is_active": "Active",

  "QA.start_review": "Start Review",
  "QA.recent_reviews": "Review that has been conducted in the last 30 days",
  "QA.percentage_of_reviews": "Percentage of reviews that have been conducted",
  "QA.total_reviews": "Total reviews that have been conducted",
  "QA.percentage_review_value": "Percentage Review: {{value}}%",
  "QA.total_review_value": "Total Review: {{value}} reviews",
  "QA.percentage": "Percentage",
  "QA.total": "Total",

  "QA.review_conversation": "Conversation Review",
  "QA.select_division": "Select the division to be reviewed",
  "QA.division_required": "Division is required",
  "QA.select_division_placeholder": "Select division",
  "QA.conversation_date": "Conversation Date",
  "QA.conversation_date_required": "Conversation date is required",
  "QA.next_btn": "Next",
  "QA.success_submit_review": "Review successfully saved",
  "QA.category_placeholder": "Enter your feedback",
  "QA.agent_required": "Agent is required",
  "QA.select_agent": "e.g. A",
  "QA.done_btn": "Done",

  "QA.category": "Category",
  "QA.all_category": "All Categories",
  "QA.no_category": "No category available",
  "QA.category_score": "Category Score",
  "QA.to": "to",
  "attachment.template": "Attachment Template",
  "attachment.image": "Attachment [Image]",
  "attachment.docs": "Attachment [Document]",
  "warning.unsupported_file_type_image":
    "Unsupported image format. Please use common image files.",
  "warning.unsupported_file_type_docs":
    "Unsupported document format. Please use common document files.",
  "warning.file_size_limit": "File {{type}} must be smaller than {{value}}MB!",
  "success.upload_file": "File {{value}} has been successfully uploaded.",
  "warning.required_upload": "Please upload file {{value}}",
  "btn.upload": "Click to upload",
  attachment: "Attachment",
  "warning.supported_media":
    "Supported file types: Images - Max {{image}}, Documents - Max {{document}}",
  "warning.all_media": "Sorry, the media you uploaded is not supported.",
  "failed.upload_file": "File {{value}} failed to upload. {{message}}",
  "contact.block_description":
    "This contact has been blocked. You will not receive messages from this contact",
  "contact.block_confirmation": "Are you sure you want to block this contact?",
  "contact.unblock_confirmation":
    "Are you sure you want to unblock this contact?",
  "contact.block_success": "Successfully blocked contact",
  "contact.block_failed": "Failed to block contact",
  "contact.unblock_success": "Successfully unblocked contact",
  "contact.unblock_failed": "Failed to unblock contact",
  "btn.block": "Block",
  "btn.unblock": "Unblock",
  otp_verification_channel_label: "Resend code by registered contact",
  otp_resend_via_registered_contact:
    "The OTP code has been resent to your registered {{channel}}.",

  "QA.comment": "Comment",
  "QA.detail_review": "Review Detail",
  "QA.delete_review_confirm": "Are you sure you want to delete this review?",
  "QA.delete_review_success": "Review successfully deleted",

  "popconfirm.title.submit_and_next":
    "Are you sure you want to submit and continue this review?",
  "QA.skip_confirmation": "Don't show this confirmation again",

  "settings.quality_assurance": "Adjust the Quality Assurance categories",
  "permission.quality_assurance": "Quality Assurance",
  "permission.setting_quality_assurance": "Quality Assurance",

  "QA.title_notfound": "Conversation Not Found",
  "QA.title_notfound_description":
    "Sorry, no conversation found in this time range, please select another time range.",
  "QA.title_complete": "All conversations have been reviewed",
  "QA.title_complete_description": "Thank you for reviewing the conversations.",

  "popconfirm.title.submit_and_finish":
    "Are you sure you want to submit and finish this review?",
  "QA.title_save_next": "Save & Next",
  "QA.title_save_finish": "Save & Finish",
  "QA.title_cancel": "Cancel",
  "forbidden_page.message":
    "Sorry, you are not authorized to access this page.",

  "assign.notes": "Notes",
  "assign.notes_placeholder": "Enter notes",
  ticketing: "Ticketing",
  "ticketing.title": "Title",
  "ticketing.add_ticket": "Add Ticket",
  "permission.delete_quality_assurance": "Delete Quality Assurance",
  "permission.delete_quality_assurance_failed":
    "You are not authorized to delete this review",
  invalid_email_address_format: "Invalid email address format.",

  "reports.detail-auto-transfer-conversation":
    "Detail Auto Transfer Conversation",
  "ticketing.successfully_add_comment": "Successfully added comment",
  "ticketing.error_add_comment": "Failed to add comment",
  "ticketing.successfully_delete_comment": "Successfully deleted comment",
  "ticketing.error_delete_comment": "Failed to delete comment",
  "ticketing.to": "To",
  "ticketing.send": "Send",
  "ticketing.cancel": "Cancel",
  "ticketing.reply": "Reply",
  "ticketing.write_reply": "Write Reply",
  "ticketing.back": "Back",
  "ticketing.successfully_update_due_date": "Successfully updated due date",
  "ticketing.error_update_due_date": "Failed to update due date",
  "ticketing.created_by": "Created by",
  "ticketing.last_response": "Last Response",
  "ticketing.due_date": "Due Date",
  "ticketing.update_due_date": "Update Due Date",
  "ticketing.select_due_date": "Select Due Date",
  "ticketing.due_date_required": "Due date is required",
  "ticketing.properties": "Properties",
  "ticketing.tag": "Tag",
  "ticketing.select_tag": "Select Tag",
  "ticketing.contact_tag": "Tag Contact",
  "ticketing.select_contact_tag": "Select Tag Contact",
  "ticketing.category": "Category",
  "ticketing.select_category": "Select Category",
  "ticketing.status": "Status",
  "ticketing.select_status": "Select Status",
  "ticketing.priority": "Priority",
  "ticketing.select_priority": "Select Priority",
  "ticketing.priority_required": "Priority is required",
  "ticketing.assigned_agent": "Assigned Agent",
  "ticketing.select_agent": "Select Agent",
  "ticketing.update": "Update",

  "ticketing.all": "All",
  "ticketing.overdue": "Overdue",
  "ticketing.approaching_due": "Approaching Due",
  "ticketing.no_due_date": "No Due Date",
  "ticketing.unassigned": "Unassigned",
  "ticketing.assigned_to_me": "Assigned to Me",
  "ticketing.assigned_to_team": "Assigned to Team",
  "ticketing.last_hour": "In the last {{value}} hours",
  "ticketing.last_day": "In the last {{value}} days",
  "ticketing.last_week": "In the last {{value}} weeks",

  "ticketing.recent_activity": "Recent Activity",
  "ticketing.select_recent_activity": "Select Recent Activity",
  "ticketing.sla_status": "SLA Status",
  "ticketing.select_sla_status": "Select SLA Status",
  "ticketing.assignment_status": "Assignment Status",
  "ticketing.select_assignment_status": "Select Assignment Status",
  "ticketing.has_comments": "Has Comments",
  "ticketing.select_has_comments": "Select Has Comments",
  "ticketing.has_attachments": "Has Attachments",
  "ticketing.select_has_attachments": "Select Has Attachments",
  "ticketing.contact": "Contact",
  "ticketing.select_contact": "Select Contact",
  "ticketing.select_assigned_agent": "Select Assigned Agent",
  "ticketing.created_at": "Created At",
  "ticketing.updated_at": "Updated At",

  "ticketing.filter_options": "Filter Options",
  "ticketing.filter": "Filter",
  "ticketing.reset_filter": "Reset Filter",
  "ticketing.save": "Save",

  "ticketing.source": "Source",
  "ticketing.select_source": "Select Source",
  "ticketing.enter_title": "Enter title",
  "ticketing.please_input_title": "Title is required",
  "ticketing.enter_description": "Enter description...",
  "ticketing.please_select_status": "Status is required",
  "ticketing.please_select_priority": "Priority is required",
  "ticketing.please_select_source": "Source is required",

  "ticketing.ticket": "Ticket",
  "ticketing.customer": "Customer",
  "ticketing.ticket_detail": "Ticket Detail",
  "ticketing.tickets": "Tickets",
  "ticketing.description": "Description",
  "ticketing.attachment": "Attachment",

  "ticketing.ticket_created": "Ticket created successfully",
  "ticketing.ticket_created_failed": "Failed to create ticket",

  "ticketing.add_tag_ticketing": "Add Tag",
  "ticketing.tag_created": "Tag created successfully",
  "ticketing.tag_created_failed": "Tag gagal dibuat",
  "ticketing.required_tag_name": "Tag name is required",
  "ticketing.enter_tag_name": "Enter tag name",
  "ticketing.select_color": "Select color",
  "ticketing.required_tag_color": "Tag color is required",

  "ticketing.show_deleted": "Show Deleted",
  "ticketing.yes": "Yes",
  "ticketing.no": "No",

  "ticketing.successfully_delete_ticket": "Ticket successfully deleted",
  "ticketing.error_delete_ticket": "Failed to delete ticket",
  export_successful: "Export successfully downloaded",
  export_failed: "Export failed to download",
  "billing.remaining_balance_notification":
    "Remaining balance {{balance}}, please top up balance immediately",
  "billing.chat_not_available": "Chat Not Available",
  "billing.balance_exhausted_message":
    "Your balance has been exhausted. Please top up your balance first to continue using the chat service.",
  "QA.no_more_previous_messages": "No more previous messages",
  "ticketing.ticket_not_found": "Ticket not found",
  "ticketing.ticket_not_found_subtitle":
    "Sorry, ticket not found or has been deleted",
  "ticketing.slug_already_used": "Slug already used",
  "ticketing.edit_tab": "Edit Tab",
  "ticketing.add_new_tab": "Add New Tab",
  "ticketing.title_required": "Title is required",
  "ticketing.title_placeholder": "Example: Urgent Ticket, Pending Ticket, etc",
  "ticketing.slug_required": "Slug is required",
  "ticketing.slug_pattern":
    "Slug can only contain lowercase letters, numbers, dash (-), and underscore (_)",
  "ticketing.slug": "Slug",
  "ticketing.slug_tooltip":
    "Slug is used for URL. It can only contain lowercase letters, numbers, dash (-), and underscore (_)",
  "ticketing.slug_placeholder": "Example: urgent-tickets, pending-tickets, etc",
  "ticketing.default_filters": "Default Filters",
  "ticketing.configure_filters": "Configure Default Filters",
  "ticketing.filters_default_required":
    "Filters default is required at least one",
  "ticketing.deleted_at": "Deleted at {{value}}",
  "ticketing.preview": "Preview",
  export_successful_user_ratings: "Export User Ratings successfully downloaded",
  export_failed_user_ratings: "Export User Ratings failed to download",
  "error.failed_to_get_data_from_facebook": "Failed to get data from Facebook",
  "error.failed_to_connect_whatsapp":
    "An error occurred while connecting WhatsApp",
  "whatsapp.success_connect_to_server":
    "WhatsApp successfully connected to the server crm.id",
  "error.failed_to_connect_whatsapp_to_server":
    "An error occurred while connecting WhatsApp with the server crm.id",
  "whatsapp.complete_information_channel":
    "Complete Information Channel WhatsApp",
  "whatsapp.name_channel": "Nama Channel",
  "whatsapp.name_channel_tooltip":
    "Name must be the same as the one you registered on Facebook",
  "whatsapp.please_input_name_channel": "Please input name channel",
  "whatsapp.input_name_channel": "Input name channel",
  "whatsapp.phone_number_channel": "Phone Number Channel",
  "whatsapp.phone_number_channel_tooltip":
    "Phone number must be the same as the one you registered on Facebook",
  "whatsapp.please_input_phone_number_channel": "Please input phone number",
  "whatsapp.input_phone_number_channel": "Input phone number",
  "whatsapp.invalid_phone_number_format": "Invalid phone number format",

  "webhook.title": "Webhook",
  webhook: "Webhook",
  "webhook.subtitle":
    "Receive real-time data change notifications without calling the API.",
  "webhook.configuration": "Webhook Configuration",
  "webhook.configuration_subtitle":
    "To receive notifications when data changes, you need to set up a webhook endpoint for your application",

  "webhook.url_cannot_be_the_same_as_the_original_webhook_url":
    "URL cannot be the same as the verification URL",
  "webhook.url_must_use_https": "URL must use HTTPS",
  "webhook.url_must_have_valid_structure": "URL must have a valid structure",
  "webhook.url_must_have_endpoint_after_domain":
    "URL must have an endpoint after the domain",
  "webhook.url_must_start_with_base_url":
    "URL must start with base URL ({{baseUrl}})",
  "webhook.url_must_have_endpoint_after_base_url":
    "URL must have an endpoint after base URL ({{baseUrl}})",
  "webhook.url_must_have_single_endpoint_after_base_url":
    "URL must have a single endpoint after base URL ({{baseUrl}})",
  "webhook.edit_webhook": "Edit Webhook",
  "webhook.url": "URL",
  "webhook.url_required": "URL is required",
  "webhook.url_example": "example: {{url}}",
  "webhook.save": "Save",
  "webhook.script_example_title": "Script Example",
  "webhook.script_example_subtitle":
    "Download webhook usage examples in the following programming languages:",
  "webhook.script_download_success": "Script downloaded successfully",
  "webhook.script_copy_success": "Script copied successfully",
  "webhook.script_copy_error": "Failed to copy script",
  "webhook.test_webhook_success": "Successfully tested webhook",
  "webhook.object": "Object",
  "webhook.test": "Test",
  "webhook.subscribed": "Subscribed",
  "webhook.callback_url": "Callback URL",
  "webhook.callback_url_tooltip":
    "Here are all the objects for which you can receive notifications via webhook",
  "webhook.copy_signature_secret_success":
    "Signature secret copied successfully",
  "webhook.copy_signature_secret_error": "Failed to copy signature secret",
  "webhook.regenerate_signature_secret_success":
    "Successfully updated signature secret",
  "webhook.regenerate_signature_secret_error":
    "Failed to update signature secret",
  "webhook.regenerate_signature_secret": "Regenerate signature secret",
  "webhook.verify_webhook_success": "Successfully verified callback URL",
  "webhook.verify_webhook_error": "Failed to verify callback URL",
  "webhook.setup_url_webhook_success": "Successfully updated callback URL",
  "webhook.setup_url_webhook_error": "Failed to update callback URL",
  "webhook.activate_webhook": "Activate Webhook",
  "webhook.activate_webhook_success": "Successfully activated webhook",
  "webhook.activate_webhook_error": "Failed to activate webhook",
  "webhook.callback_url_description":
    "This is the URL that will be called by the CRM when there are data changes.",
  "webhook.signature_secret": "Signature Secret",
  "webhook.signature_secret_tooltip":
    "This signature secret will only be displayed once",
  "webhook.verify": "Verify",
  "webhook.update_webhook_settings_success":
    "Successfully updated callback URL",
  "webhook.update_webhook_settings_error": "Failed to update webhook settings",
  wa_message_webhook_url: "Webhook Message",
  wa_message_status_webhook_url: "Webhook Status Message",
  "inbox-ticketing": "Inbox Ticketing",
  "inbox-ticketing.delete_success": "Successfully deleted inbox ticketing",
  "inbox-ticketing.delete_failed": "Failed to delete inbox ticketing",
  "inbox-ticketing.update_success": "Successfully updated inbox ticketing",
  "inbox-ticketing.update_failed": "Failed to update inbox ticketing",
  "inbox-ticketing.add_success": "Successfully added inbox ticketing",
  "inbox-ticketing.add_failed": "Failed to add inbox ticketing",
  "inbox-ticketing.is_active": "Active",
  "settings.inbox_ticketing": "Configure your inbox ticketing",
  "ticketing.attachment_tooltip":
    "File must be file type: jpg, jpeg, pdf, png, gif, doc, docx, xls, xlsx, and Maximum 10MB",
  "ticketing.attachment_error_file_type": "File must be file type: {{value}}",
  "ticketing.attachment_error_file_size":
    "File must be file size: Maximum {{value}}MB",
  "settings.webhook": "Connect your application with webhook",
  "conversation.filter_open": "Open",
  "conversation.filter_closed": "Closed",

  "ticketing.comment_or_attachment_required":
    "Please enter a comment or attach a file",
  "ticketing.move_to_inbox": "Move to Inbox",
  "ticketing.select_inbox": "Select Inbox",
  "ticketing.inbox_required": "Inbox is required",
  "ticketing.select_inbox_placeholder": "Select destination inbox",
  "ticketing.successfully_move_to_inbox": "Successfully moved ticket to inbox",
  "ticketing.error_move_to_inbox": "Failed to move ticket to inbox",

  "ticketing.notification.new_ticket": "New Ticket",
  "ticketing.notification.new_ticket_desc":
    'New ticket created with title "{{value}}"',
  "ticketing.notification.ticket_assigned": "Ticket Assigned",
  "ticketing.notification.ticket_assigned_desc":
    'Ticket "{{value}}" has been assigned to agent',
  "ticketing.notification.ticket_deleted": "Ticket Deleted",
  "ticketing.notification.ticket_deleted_desc":
    'Ticket "{{value}}" has been deleted',
  "ticketing.notification.new_comment": "New Comment",
  "ticketing.notification.new_comment_desc":
    'New comment added to ticket "{{value}}"',
  "ticketing.notification.comment_deleted": "Comment Deleted",
  "ticketing.notification.comment_deleted_desc":
    'Comment deleted from ticket "{{value}}"',

  "ticketing.draft_deleted": "Draft successfully deleted",
  "ticketing.draft_applied": "Draft successfully applied",
  "ticketing.drafts_available": "{{count}} drafts available",
  "ticketing.view_drafts": "View Draft",
  "ticketing.saved_drafts": "Saved Drafts",
  "ticketing.delete_all_drafts_confirm": "Delete all drafts?",
  "ticketing.delete_all": "Delete All",
  "ticketing.no_drafts": "No drafts saved",
  "ticketing.apply": "Apply",
  "ticketing.delete_draft_confirm": "Delete draft?",
  "ticketing.untitled": "Untitled",
  "ticketing.active": "Active",
  "ticketing.saved_at": "Saved",

  "ticketing.error_update_ticket_title": "Failed to update ticket title",
  "ticketing.successfully_update_ticket_title":
    "Successfully updated ticket title",
  "ticketing.no_tickets_yet": "No tickets yet",
  "ticketing.view_detail": "View detail",

  "ticketing.notification.ticket_inbox_changed": "Ticket Inbox Changed",
  "ticketing.notification.ticket_inbox_changed_desc":
    'Ticket inbox "{{value}}" has been changed by {{user}}',
  "conversation.no_chat_yet": "No chat yet",
  "conversation.please_start_chatting_first": "Please start chatting first",

  "ticketing.last_month": "In the last {{value}} months",
  "apiKey.create_title": "Add API Key",
  "apiKey.create_success": "API Key created successfully",
  "apiKey.create_error": "Failed to create API Key",
  "apiKey.name_label": "Token Name",
  "apiKey.name_placeholder": "Enter token name",
  "apiKey.name_required": "Please enter token name",
  "apiKey.name_description":
    "Enter a token name related to the application using the token or the purpose of the token.",
  "apiKey.max_expiration_date": "Maximum token expiration date",
  "apiKey.detail_title": "API Key Detail",
  "apiKey.not_found_title": "Token not found",
  "apiKey.not_found_subtitle": "Sorry, Token not found. Please check again.",
  "apiKey.delete_confirm": "Are you sure you want to delete this token?",
  "apiKey.delete_success": "Token deleted successfully",
  "apiKey.delete_error": "Failed to delete token. Please try again.",
  "apiKey.name_label_detail": "Token Name:",
  "apiKey.token_label": "Token:",
  "apiKey.status_label": "Status:",
  "apiKey.status_expired": "Expired",
  "apiKey.status_active": "Active",
  "apiKey.expiration_date_label": "Expiration Date:",
  "apiKey.last_used_label": "Last Used:",
  "apiKey.last_used_never": "Never used",
  "apiKey.created_date_label": "Created Date:",
  "apiKey.expiration_date_form_label": "Expiration Date",
  "apiKey.expiration_date_placeholder": "Select expiration date",
  "apiKey.expiration_date_required": "Please select expiration date",
  "apiKey.expiration_days": "{{days}} Days",
  "apiKey.expiration_years_one": "{{years}} Year",
  "apiKey.expiration_years_other": "{{years}} Years",
  "apiKey.expiration_custom": "Custom",
  "apiKey.date_preset_tomorrow": "Tomorrow",
  "apiKey.date_preset_next_week": "Next Week",
  "apiKey.date_preset_next_month": "Next Month",
  "apiKey.date_preset_next_year": "Next Year",
  "apiKey.guide_button": "Guide",
  "apiKey.description":
    "You can create personal access tokens for each application that requires a token when integrating with Kledo.",
  "apiKey.stats_active": "Active tokens",
  "apiKey.stats_expired": "Expired tokens",
  "apiKey.stats_never_used": "Never used tokens",
  "apiKey.table_name": "Token Name",
  "apiKey.table_token": "Token",
  "apiKey.table_created_date": "Created Date",
  "apiKey.table_last_used": "Last Used Date",
  "apiKey.table_expiration_date": "Expiration Date",
  "apiKey.table_action": "Action",
  "apiKey.overview_title": "API Overview",
  "apiKey.overview_endpoint_label": "API Endpoint URL:",
  "apiKey.overview_documentation_label": "API Endpoint Documentation:",
  "apiKey.overview_script_label": "PHP Demo Script:",
  "apiKey.copy_button_title": "Copy",
  "apiKey.script_copied_fallback": "Script copied",
  "apiKey.token_alert_title": "Your Personal Access Token",
  "apiKey.token_alert_description":
    "Please copy and save the token code above, this token code can only be accessed once",
  "apiKey.token_copied": "Token copied successfully",
  "billing.choose_plan": "Choose Plan",
  "billing.choose_term": "Choose Contract Duration",
  "billing.add_addon": "Add Addon",
  "billing.hide_addon": "Hide Addon",
  "billing.calculation_detail": "Calculation Details",
  "billing.total_bill": "Total Bill",
  "billing.upgrade_now": "Upgrade Now",
  "billing.renew_now": "Renew Now",
  "billing.most_popular": "Most Popular",
  "billing.discount_percent": "{{value}}% Discount",
  "billing.save_amount": "Save {{value}}",
  "billing.per_month": "/month",
  "billing.term_months": "{{value}} Months",
  "billing.term_years": "{{value}} Years",
  "billing.whatsapp_channels": "{{value}} WhatsApp Channel",
  "billing.chat_rows": "{{value}} Chat rows",
  "billing.subtotal_plan": "Plan Subtotal",
  "billing.subtotal_addon": "Addon Subtotal",
  "billing.subtotal": "Subtotal",
  "billing.saving_label": "Saving",
  "billing.discount_label": "Discount",
  "billing.upgrade_success": "Upgrade order created successfully",
  "billing.renew_success": "Renew order created successfully",
  "billing.no_plan_available": "No upgrade plan available",
  "billing.payment_success": "Payment successful",
  "billing.payment_pending":
    "Payment is being processed, please complete the payment",
  "billing.payment_error": "Payment failed, please try again",
  "billing.payment_cancelled": "Payment cancelled",
  "billing.token_required_to_make_payment":
    "Token is required to make a payment",
  "billing.payment_gateway_not_ready":
    "Payment gateway is not ready, please refresh the page",
  "billing.upgrade_disclaimer":
    "By clicking the button above, you agree to our <terms>Terms of Service</terms> and confirm that you have read our <privacy>Privacy Policy</privacy>.",
  "billing.thank_you": "Thank you",
  "billing.email_invoice_sent":
    "The invoice has been sent to your email address.",
  "billing.please_pay_amount":
    "Please make the payment of <b>{{value}}</b> by clicking the button below",
  "billing.back_to_billing": "Back to Billing",
  "billing.pay_now": "Pay Now",
  "billing.subtitle": "Manage your usage and payment history.",
  "billing.export_invoice": "Export Invoice",
  "billing.on_demand_section": "On Demand Balance",
  "billing.subscription_section": "Subscription Balance",
  "billing.outstanding_balance": "Outstanding Balance",
  "billing.outstanding_balance_tooltip":
    "Balance available for on-demand service usage.",
  "billing.current_usage_monthly": "Current Month Usage",
  "billing.current_usage_monthly_tooltip":
    "Total service usage in the current month.",
  "billing.total_conversation": "Total Conversations (Chat)",
  "billing.total_conversation_tooltip":
    "Total number of chat conversations ever made.",
  "billing.balance_negative": "Your balance is negative",
  "billing.balance_sufficient": "Your balance is sufficient",
  "billing.please_topup": "Please top up your balance",
  "billing.no_comparison_data": "No comparison data from last month yet",
  "billing.compared_to_last_month": "{{value}}% vs last month",
  "billing.total_chat_until_now": "Total chats up to now",
  "billing.current_plan": "Current Plan",
  "billing.subscription_plan_name": "{{value}} Plan",
  "billing.no_action_available":
    "No action available for this plan at the moment.",
  "billing.no_subscription_data": "Subscription data not available",
  upgrade: "Upgrade",
  "billing.col_product": "Product",
  "billing.col_qty": "Quantity",
  "billing.col_term": "Contract",
  "billing.col_per_month": "Per Month",
  "billing.on_demand": "On Demand",
  "billing.subscription": "Subscription",
  "billing.col_order_date": "Order Date",
  "billing.col_period": "Period",
  "billing.col_paid_date": "Payment Date",
  "billing.col_status": "Status",
  "billing.status_paid": "Paid",
  "billing.status_unpaid": "Unpaid",
  "billing.pay": "Pay",
  "billing.download_invoice": "Download Invoice",
  "billing.delete_transaction_success": "Transaction deleted successfully",
  "billing.payment_waiting_title": "Waiting for Payment",
  "billing.payment_waiting_desc":
    "Your account will be active once the payment has been made. If you have already made the payment, please click the button below. Thank you.",
  "billing.go_to_crm": "Go to CRM",
  "billing.go_to_billing": "Go to CRM Billing",
  "billing.payment_success_title": "Payment Successful",
  "billing.payment_success_desc": "Your account has been activated. Thank you.",
  "billing.active_plan": "Active Plan",
  "billing.no_addon": "No add-ons available for this subscription yet.",
  "billing.addon": "Addon",
  "billing.active_until": "Active until",
  "billing.forever": "Forever",
  "billing.current_usage_title": "Current Usage",
  "billing.features_title": "Features You Get",
  "billing.view_plan_detail": "View Plan Details",
  "billing.status_active": "Active",
  "billing.channel_whatsapp": "WhatsApp Channel",
  "billing.chat_rows_label": "Chat Rows",
  "billing.unit_channel": "Channel",
  "billing.unit_rows": "Rows",
  "billing.on_demand_desc": "Manage your On Demand balance and usage.",
  "billing.addon_section": "Add-on",
  "billing.addon_section_desc":
    "Add add-ons to expand your service capacity without changing your subscription plan.",
  "billing.no_addon_available": "No add-ons available to purchase yet.",
  "billing.no_subscribed_addon": "No subscription add-ons yet.",
  "billing.addon_title": "Add Add-on",
  "billing.choose_addon": "Choose Add-on",
  "billing.buy_now": "Buy Now",
  "billing.addon_success": "Add-on order created successfully",
  "billing.addon_empty_selection":
    "Choose an add-on and set the quantity to see the breakdown.",
  "billing.addon_free_limit_reached":
    "The Free plan can't add any add-ons. Upgrade to a paid plan first to buy add-ons.",
  addon: "Add-on",
  "billing.col_unit_price": "Unit Price",
  otp_change_email_old_label: "OTP code from old email",
  otp_change_email_new_label: "OTP code from new email",
  // [crm-iso] START — hidden feature (lihat CrmIsoSetting/TEARDOWN.md)
  "crm_iso.title": "CRM ISO Settings",
  "crm_iso.subtitle":
    "Manage affected providers & agents and agent name mapping. Every change is saved automatically.",
  "crm_iso.add": "Add",
  "crm_iso.cancel": "Cancel",
  "crm_iso.delete": "Delete",
  "crm_iso.confirm_delete_title": "Delete this item?",
  "crm_iso.confirm_delete_agent_with_mapping_title":
    "Delete this affected agent?",
  "crm_iso.confirm_delete_agent_with_mapping_desc":
    "This agent is used as a main agent in an agent name mapping. Deleting it will also remove that mapping.",
  "crm_iso.col_action": "Action",
  "crm_iso.toggle": "Enable Feature",
  "crm_iso.toggle_desc": "Turn the CRM ISO feature on or off.",
  "crm_iso.on": "On",
  "crm_iso.off": "Off",
  "crm_iso.affected_agents": "Affected Agents",
  "crm_iso.affected_agents_desc": "Agents included in this feature's scope.",
  "crm_iso.add_agent": "Add Agent",
  "crm_iso.col_agent_name": "Agent Name",
  "crm_iso.empty_agents": "No agents yet",
  "crm_iso.select_agent_hint": "Select one or more agents to add.",
  "crm_iso.agent_name_changes": "Agent Name Mapping",
  "crm_iso.agent_name_changes_desc":
    "Assign one main agent that represents several linked agents.",
  "crm_iso.add_agent_name_change": "Add Mapping",
  "crm_iso.edit_agent_name_change": "Edit Mapping",
  "crm_iso.save": "Save",
  "crm_iso.main_agent": "Main Agent",
  "crm_iso.main_agent_hint":
    "Chosen from the affected agents list; only one allowed.",
  "crm_iso.select_main_agent": "Select main agent",
  "crm_iso.connected_agents": "Linked Agents",
  "crm_iso.select_connected_agents": "Select linked agents",
  "crm_iso.main_included_note":
    "The main agent is automatically included as a linked agent.",
  "crm_iso.mapping_flow_hint": "Select a main agent first to start mapping.",
  "crm_iso.col_main_agent": "Main Agent",
  "crm_iso.col_connected_agents": "Linked Agents",
  "crm_iso.empty_agent_name_changes": "No mapping yet",
  "crm_iso.no_affected_agents_hint": "Add affected agents first.",
  "crm-iso-setting": "CRM ISO Settings",
  "crm_iso.col_agent_email": "Email",
  // [crm-iso] END
  "import_contact.title": "Import Contact",
  "import_contact.button": "Import",
  "import_contact.step_upload": "Upload File",
  "import_contact.step_check": "Check Data",
  "import_contact.step_progress": "Import in progress",
  "import_contact.step_success": "Import Successful",
  "import_contact.instruction_title":
    "Follow these steps to import your contacts",
  "import_contact.step1_title": "Download the contact template file",
  "import_contact.step1_desc":
    "Start by downloading the template file in Excel format. This file has the header columns that CRM ID needs to import your contact details.",
  "import_contact.download_template": "Download Template File",
  "import_contact.download_example": "Download Example File",
  "import_contact.step2_title": "Copy your contact details into the template",
  "import_contact.step2_desc":
    "Using Excel or any other spreadsheet software, enter your contact details into the CRM ID template file. Make sure the contact details match the header columns in the template.",
  "import_contact.important": "IMPORTANT :",
  "import_contact.important_1":
    "Do not change the column headers in the template. They are required for the import to work.",
  "import_contact.important_2":
    "A maximum of 3,000 contacts can be imported at one time.",
  "import_contact.important_3":
    "You can also use an already imported file to update all of your contacts, saving time and effort compared to updating contacts one by one through the browser.",
  "import_contact.important_4":
    "The import process uses Contact Name, Company, and Contact Type to determine whether a contact already exists. If the contact exists it will be updated, otherwise a new contact will be created. Contacts are never deleted, so you can safely update only some of your contacts without worrying about losing data on the others.",
  "import_contact.step3_title": "Upload the updated template here",
  "import_contact.step3_desc": "Save the updated template file :",
  "import_contact.upload_hint": "Drag file here to upload",
  "import_contact.upload": "Upload",
  "import_contact.check_title": "Please check the data to be imported",
  "import_contact.check_desc":
    'If the data to be imported matches your expectations, please click the "Import Now" button.',
  "import_contact.valid": "Valid",
  "import_contact.invalid": "Invalid",
  "import_contact.total": "Total",
  "import_contact.import_now": "Import Now",
  "import_contact.row": "Row",
  "import_contact.error_message": "Error",
  "import_contact.col_address": "Billing Address",
  "import_contact.col_birthday": "Date of Birth",
  "import_contact.col_error": "Error",
  "import_contact.valid_detail_unavailable":
    "Valid row details are not available to display.",
  "import_contact.progress_title": "Import in progress",
  "import_contact.progress_desc":
    "It's fine to close this page or import another file. You will be notified by email when the import is complete.",
  "import_contact.preparing": "Preparing the import process",
  "import_contact.progress_count": "{{count}} of {{total}} rows processed",
  "import_contact.import_other": "Import another file",
  "import_contact.back_to_list": "Go to contact list",
  "import_contact.success_title": "Import Successful",
  "import_contact.success_count":
    "{{count}} contact rows imported successfully.",
  "import_contact.show_detail": "Show detail",
  "import_contact.hide_detail": "Hide detail",
  "import_contact.succeed": "Succeeded",
  "import_contact.failed": "Failed",
  "import_contact.err_file_type":
    "File format must be .csv, .xls, .xlsx, or .txt",
  "import_contact.err_file_size": "Maximum file size is 10MB",
  "import_contact.upload_failed": "Failed to upload file",
  "import_contact.download_failed": "Failed to download file",
  "companies.select_company": "Select Company",
  "warning.wa_param_no_newline":
    "Line breaks (Enter) aren't allowed in WhatsApp template variables.",
  "warning.wa_param_adjusted":
    "The pasted text was adjusted to meet WhatsApp rules: line breaks & tabs removed, extra spaces trimmed.",
  "notification.crm_id_is_now_on_google_play": "CRM.ID is now on Google Play",
  "footer.get_it_on_google_play": "Get it on Google Play",
  "reports.desc_chat_lines_count":
    "See the total number of chat lines within a given period.",
  "reports.desc_online_duration":
    "Analyze the team's online duration within a given period.",
  "reports.desc_team_response_time":
    "See the team's average response time to incoming messages.",
  "reports.desc_individual_response_time":
    "Analyze each individual's response time.",
  "reports.desc_auto_transfer_conversation":
    "See data on conversations that were transferred automatically.",
  "reports.desc_statistics_user_ratings":
    "A summary of rating statistics from users.",
  "reports.desc_list_of_user_ratings": "See the detailed list of user ratings.",
  "reports.desc_data_quality_assurance": "See quality assurance result data.",
  "reports.desc_statistics_quality_assurance":
    "Analyze quality assurance result statistics.",
  "reports.desc_chat_volume_statistics":
    "See chat volume statistics for each agent.",
  "reports.desc_chat_volume_statistics_daily":
    "See daily chat volume statistics within a given period.",
  "reports.need_other_report_title": "Need another report?",
  "reports.need_other_report_subtitle":
    "If you need additional reports, please contact your administrator.",
  "reports.contact_admin": "Contact Admin",
  "reports.search_placeholder": "Search reports...",
  "reports.no_report_found": "No reports found.",
  "reports.volume_incoming": "Incoming Chat Volume",
  "reports.desc_volume_incoming":
    "See the volume of incoming chats within a given period.",
  "reports.vi_export": "Export",
  "reports.vi_subtitle": "Summary of incoming conversations in Kledo CRM.",
  "reports.vi_team": "Team",
  "reports.vi_team_all": "All Teams",
  "reports.vi_period_label": "Period",
  "reports.vi_per_hour": "Hourly",
  "reports.vi_per_day": "Daily",
  "reports.vi_per_week": "Weekly",
  "reports.vi_per_month": "Monthly",
  "reports.vi_kpi_total": "Total Incoming",
  "reports.vi_kpi_avg_day": "Average / Day",
  "reports.vi_kpi_peak_hour": "Peak Hour (Average)",
  "reports.vi_kpi_active_agents": "Total Active Agents",
  "reports.vi_kpi_avg_agent_day": "Average / Agent / Day",
  "reports.vi_section_heatmap": "Incoming Heatmap by Hour",
  "reports.vi_section_heatmap_daily": "Daily Incoming Calendar",
  "reports.vi_section_heatmap_weekly": "Weekly Incoming Heatmap",
  "reports.vi_section_heatmap_monthly": "Monthly Incoming Heatmap",
  "reports.vi_week": "Week",
  "reports.vi_month": "Month",
  "reports.vi_section_interval": "Incoming per Interval (Summary)",
  "reports.vi_section_trend": "Incoming Trend",
  "reports.vi_section_detail": "Incoming Detail",
  "reports.vi_event_label": "Event Type",
  "reports.vi_event_all": "All Events",
  "reports.vi_event_created": "New Conversation",
  "reports.vi_event_assign": "Assigned",
  "reports.vi_event_take": "Taken by Agent",
  "reports.vi_event_auto_transfer": "Auto Transfer",
  "reports.vi_kpi_total_sub": "vs previous period",
  "reports.vi_unit_incoming": "incoming",
  "reports.vi_interval_hour": "Per Hour (Average)",
  "reports.vi_interval_day": "Per Day (Total)",
  "reports.vi_interval_week": "Per Week (Total)",
  "reports.vi_interval_month": "Per Month (Total)",
  "reports.vi_unit_per_hour": "incoming / hour",
  "reports.vi_unit_per_day": "incoming / day",
  "reports.vi_unit_per_week": "incoming / week",
  "reports.vi_unit_per_month": "incoming / month",
  "reports.vi_heatmap_less": "Less",
  "reports.vi_heatmap_more": "More",
  "reports.vi_heatmap_hourly_only":
    "Heatmap is available when period = Hourly.",
  "reports.vi_trend_series": "Incoming",
  "reports.vi_col_agent": "Agent",
  "reports.vi_col_team": "Team",
  "reports.vi_col_total": "Total Incoming",
  "reports.vi_col_interval_total": "Total per Hour Interval",
  "reports.vi_col_per_day_avg": "Per Day (Average)",
  "reports.vi_col_per_week_avg": "Per Week (Average)",
  "reports.vi_col_per_month_avg": "Per Month (Average)",
  "reports.vi_search_agent": "Search Agent / Team...",
  "reports.vi_column": "Column",
  "reports.vi_export_csv": "Export CSV",
  "reports.vi_unit_day": "days",
  "reports.vi_unit_month": "months",
  "reports.vi_range_clamped":
    "The {{label}} range is limited to {{amount}} {{unit}}. Start date has been adjusted automatically.",
  "volume-incoming": "Volume Incoming",
  "apiKey.script_example_title": "Example Script",
  "apiKey.script_example_subtitle":
    "Download example usage of the CRM API in various programming languages. Replace ACCESS_TOKEN with your own API token.",
  "apiKey.script_copy_success": "Script copied successfully",
  "apiKey.script_copy_error": "Failed to copy script",
  "apiKey.script_download_success": "Script downloaded successfully",
  "conversation.volume_char_warning":
    "Only the first {{limit}} characters of each chat reply are counted as chat volume",
  "conversation.volume_not_counted_title":
    "This reply is not counted in chat volume.",
  "conversation.volume_not_counted_desc":
    "Only the first line after a customer's chat is counted as chat volume.",
  "bots.node_type": "Node type",
  "bots.node_type_reply": "Regular reply",
  "bots.node_type_handover": "Hand over to agent",
  "bots.handover_help":
    "After this reply is sent, the bot stops and the conversation is handed over to an agent.",
  "bots.delete_node": "Delete",
  "bots.delete_node_confirm_title": 'Delete node "{{name}}"?',
  "bots.delete_node_confirm_desc":
    "This node and {{count}} node(s) below it will be deleted. This action cannot be undone.",
  "bots.delete_node_confirm_desc_leaf":
    "This node will be deleted. This action cannot be undone.",
  "chatbot.success_delete_flow": "Node deleted successfully",
  "chatbot.error_delete_flow": "Node could not be deleted",
  "bots.handover_after_fallback":
    "Hand over to agent after the bot does not understand",
  "bots.handover_after_fallback_help": "times in a row · 0 = never",
  "bots.handover_after_fallback_hint":
    "If the customer types something the bot does not recognise N times in a row, the conversation is handed over to an agent. Replies after the customer reaches a final answer (e.g. 'ok', 'thanks') are not counted.",
  "bots.handover_message": "Message when handing over to an agent",
  "bots.handover_message_help":
    'Leave empty to keep using the regular "not understood" reply',
  "bots.back_to_menu_keywords": "Back to main menu keywords",
  "bots.back_to_menu_keywords_hint":
    "A customer who types one of these words is taken back to the welcome message from anywhere",
  "bots.handover_column": "Hand over to agent",
  "bots.handover_summary_never": "Never",
  "bots.handover_summary_after": "After {{count}}× not understood",
  "bots.error_handover_after_fallback_integer":
    "Handover after fallback must be an integer.",
  "bots.error_handover_after_fallback_min":
    "Handover after fallback must be at least 0.",
  "bots.error_handover_after_fallback_max":
    "Handover after fallback must not be greater than 255.",
  "bots.error_back_to_menu_keywords_max":
    "Back to menu keywords must not have more than 20 items.",
  "bots.error_back_to_menu_keyword_empty":
    "Back_to_menu_keywords.{{index}} must be a string.",
  "bots.error_back_to_menu_keyword_max":
    "Back_to_menu_keywords.{{index}} must not be greater than 191 characters.",
  "ticketing.export": "Export",
  "ticketing.export_to_xlsx": "Export to XLSX",
  "ticketing.export_to_csv": "Export to CSV",
  "ticketing.export_successful": "Ticket export downloaded successfully",
  "ticketing.export_failed": "Failed to download ticket export",
  "reports.vi_no_previous_data": "No previous data",
  "chat_lines_count.incoming": "Incoming Messages",
  "chat_lines_count.agent_reply": "Agent Replies",
  "chat_lines_count.bot_reply": "Bot Replies",
  "chat_lines_count.total": "Total",
  "inhouse_channel.title": "Inhouse Channel",
  "inhouse_channel.description":
    "Add live chat to your website. Visitor chats will arrive in the inbox just like WhatsApp chats.",
  "inhouse_channel.add_title": "Add Inhouse Channel",
  "inhouse_channel.detail_title": "Channel Detail",
  "inhouse_channel.name": "Channel Name",
  "inhouse_channel.name_placeholder": "e.g. Website Live Chat",
  "inhouse_channel.name_required": "Please enter the channel name",
  "inhouse_channel.allow_guest": "Allow Guests",
  "inhouse_channel.allow_guest_help":
    "When turned off, only visitors logged in to your website can chat (requires an identity endpoint on your website backend).",
  "inhouse_channel.active": "Active",
  "inhouse_channel.inactive": "Inactive",
  "inhouse_channel.secret_title": "Save Identity Secret",
  "inhouse_channel.secret_warning":
    "This secret is shown only once. Store it in your website backend env. Never put it in HTML/JavaScript.",
  "inhouse_channel.secret_saved": "I have saved it",
  "inhouse_channel.copied": "Copied successfully",
  "inhouse_channel.copy_failed": "Failed to copy",
  "inhouse_channel.failed": "Something went wrong, please try again",
  "inhouse_channel.session_ttl_info": "Chat sessions last {{hours}} hours",
  "inhouse_channel.install_title": "Install on Website",
  "inhouse_channel.install_desc":
    "Copy the snippet below and paste it before </body> on every page of your website.",
  "inhouse_channel.snippet_guest": "Guest Mode",
  "inhouse_channel.snippet_login": "Login Mode",
  "inhouse_channel.confirm_change_title": "Save changes?",
  "inhouse_channel.confirm_continue": "Continue",
  "inhouse_channel.deactivate_warning":
    "Deactivating the channel will immediately disconnect all visitors currently chatting.",
  "inhouse_channel.disallow_guest_warning":
    "Turning off guest access will immediately stop ongoing guest sessions. Only logged-in visitors will be able to chat.",
  "inhouse_channel.rotate_secret": "Rotate Identity Secret",
  "inhouse_channel.rotate_confirm_title": "Rotate identity secret?",
  "inhouse_channel.rotate_confirm_desc":
    "The old secret stops working immediately. Login-mode widgets on your website will fail until the backend env is updated. Guest mode and the snippet stay the same.",
  "inhouse_channel.delete": "Delete Channel",
  "inhouse_channel.delete_confirm_title": "Delete this channel?",
  "inhouse_channel.delete_confirm_desc":
    "The widget on your website will stop working and agents can no longer send messages through this channel. Conversation history remains readable in the inbox.",
  "inhouse_channel.add_card_title": "Add Channel",
  "inhouse_channel.add_card_desc": "Add a new channel",
  "inhouse_channel.guest_disabled_info":
    "Guest access is turned off. The guest mode snippet cannot be used to chat until guest access is turned back on.",
  "inhouse_channel.login_cookie": "Regular website (session cookie)",
  "inhouse_channel.login_spa": "SPA (token)",
  "inhouse_channel.spa_step1_title":
    "Step 1: create an identity endpoint on your backend",
  "inhouse_channel.spa_step1_desc":
    "The widget calls this endpoint with the user's login token (Authorization: Bearer …). It returns { identity_token } for a logged-in user, or 401 if not logged in. Store this channel's identity secret in your backend env (INHOUSE_IDENTITY_SECRET), never in the frontend.",
  "inhouse_channel.spa_step1_cors":
    "If your frontend and API are on different domains, make sure your API's CORS allows the Authorization header from the frontend domain.",
  "inhouse_channel.spa_step2_title": "Step 2: install the widget in index.html",
  "inhouse_channel.spa_step2_desc":
    "Paste it before </body>. Adjust the two lines marked ← to match your app.",
  "inhouse_channel.spa_step2_note":
    "Read the token inside identify, not once at startup. The widget calls it again whenever it needs an identity, so the latest token is always used.",
  "inhouse_channel.spa_step3_title":
    "Step 3: notify the widget on login and logout",
  "inhouse_channel.spa_step3_desc":
    "SPA pages don't reload on login/logout, so the widget must be notified.",
  "inhouse_channel.spa_step3_warning":
    "Don't skip logout. Without it, the next person on the same device can read the previous user's chats.",
  "inhouse_channel.spa_step3_note":
    "Chats sent as a guest are not lost. After login, the widget offers to merge them into the user's account.",
  "inhouse_channel.spa_step4_title": "Step 4: try it",
  "inhouse_channel.spa_step4_item1":
    "Open the website while logged out and send a message. It arrives in the inbox as a guest.",
  "inhouse_channel.spa_step4_item2":
    "Log in. The widget offers to merge the guest chat, and subsequent messages arrive under the user's name.",
  "inhouse_channel.spa_step4_item3":
    "Log out. The user's chats are no longer visible, and the widget returns to guest mode.",
  "inhouse_channel.spa_step4_note":
    'If the banner "Invalid user identity" appears, the secret in your backend env doesn\'t match this channel. It may have been rotated.',
  "inhouse_channel.login_cookie_desc":
    "PHP, Laravel, Django, WordPress, and other websites using session cookie login",
  "inhouse_channel.login_spa_desc":
    "React, Vue, Angular, and other apps using token login",
  "inhouse_channel.cookie_step1_title":
    "Step 1: create an identity endpoint on your backend",
  "inhouse_channel.cookie_step1_desc":
    "The widget calls /api/chat-identity with the user's login session cookie. It returns { identity_token } for a logged-in user, or 401 if not logged in. Store this channel's identity secret in your backend env (INHOUSE_IDENTITY_SECRET), never in the frontend.",
  "inhouse_channel.cookie_step2_title":
    "Step 2: install the widget on your website",
  "inhouse_channel.cookie_step2_desc":
    "Paste it before </body> on every page. If your endpoint URL is not /api/chat-identity, adjust data-identity-url.",
  "inhouse_channel.section_settings": "Settings",
  "inhouse_channel.section_credentials": "Credentials",
  "inhouse_channel.section_danger": "Danger Zone",
  inhouse: "Inhouse Channel",
  "inhouse_channel.section_settings_desc":
    "Basic information and channel status.",
  "inhouse_channel.section_credentials_desc":
    "API configuration for connecting the widget on your website.",
  "inhouse_channel.name_help": "This name is shown on the channel page.",
  "inhouse_channel.active_help":
    "When turned off, the channel will neither receive nor send messages.",
  "inhouse_channel.save_changes": "Save Changes",
  "inhouse_guest.promote_title": "Convert to Contact",
  "inhouse_guest.promote_desc":
    "This guest will become a permanent contact and appear in the contact list. The visitor will not be disconnected from the chat.",
  "inhouse_guest.promote_submit": "Convert to Contact",
  "inhouse_guest.promote_success": "Guest successfully converted to a contact",
  "inhouse_guest.promote_failed": "Failed to convert guest to a contact",
  "inhouse_guest.name": "Name",
  "inhouse_guest.name_required": "Please enter the contact name",
  "inhouse_guest.email": "Email",
  "inhouse_guest.email_invalid": "Invalid email format",
  "inhouse_guest.phone": "Phone Number",
  "apiKey.overview_postman_label": "Postman Collection:",
  "apiKey.download_postman": "Download Postman Collection",
  "appSetting.script_has_been_copied": "PHP Demo Script has been copied",
  "appSetting.copy_failed": "Failed to copy",
  "apiKey.video_tutorial_title": "Video Tutorial",
  "apiKey.video_tutorial_integration": "How to Integrate CRM API",
  "whatsapp.choose_number_type_title": "Choose Number Type",
  "whatsapp.number_type_new": "New number",
  "whatsapp.number_type_new_desc":
    "A number that is not used in any WhatsApp app. Once connected, the number can only be used through the CRM.",
  "whatsapp.number_type_coexistence":
    "WhatsApp Business number already used on a phone",
  "whatsapp.number_type_coexistence_desc":
    "The number stays usable in the WhatsApp Business app on the phone and in the CRM at the same time.",
  "whatsapp.coexistence_notice_title": "Before you continue",
  "whatsapp.coexistence_requirement":
    "Make sure the WhatsApp Business app on the phone is version 2.24.17 or later.",
  "whatsapp.coexistence_no_history":
    "Chat history from before the connection is not imported into the CRM.",
  "whatsapp.coexistence_not_synced":
    "Group chats, calls, catalog, and status are not synced to the CRM.",
  "whatsapp.coexistence_lost_phone_features":
    "On the phone, disappearing messages, view once, live location, and broadcast lists can no longer be used.",
  "users.invite_logged_in_title": "You are logged in on this browser",
  "users.invite_logged_in_description":
    "This invitation can't be processed while an account is logged in. Log out first to continue. That account will also be logged out in other tabs.",
  "users.invite_logout_and_continue": "Log out & continue",
  "users.invite_back_to_app": "Back to app",
  "inhouse_channel.section_header": "Widget Header",
  "inhouse_channel.section_header_desc":
    "Set the title, description, and picture shown at the top of the chat widget.",
  "inhouse_channel.header_picture": "Picture / Logo",
  "inhouse_channel.header_picture_help":
    "JPG, PNG, or WEBP, max {{size}}MB. Leave empty to use the default logo.",
  "inhouse_channel.header_picture_choose": "Choose Picture",
  "inhouse_channel.header_picture_change": "Change Picture",
  "inhouse_channel.header_picture_remove": "Remove",
  "inhouse_channel.header_picture_invalid_type":
    "Picture must be JPG, PNG, or WEBP",
  "inhouse_channel.header_picture_too_large":
    "Picture must be at most {{size}}MB",
  "inhouse_channel.header_name": "Title",
  "inhouse_channel.header_name_help": "Leave empty to use the default title.",
  "inhouse_channel.header_description": "Description",
  "inhouse_channel.header_description_help":
    "Shown below the title. Leave empty to use the default description.",
  "inhouse_channel.header_preview": "Preview",
  "inhouse_channel.header_preview_note":
    "Changes apply when customers open their next chat session.",
  "inhouse_channel.header_conflict_title": "Changes not saved",
  "inhouse_channel.header_conflict_desc":
    "Another change to this channel is being processed. Try saving again?",
  "inhouse_channel.header_retry": "Try Again",
  "inhouse_channel.header_preview_sample_date": "Yesterday",
  "inhouse_channel.header_preview_sample_message": "Hi there",
  "inhouse_channel.header_default_name": "Need help?",
  "inhouse_channel.header_default_description": "Our team is ready to help",
  // [crm-iso] START — provider terpengaruh (lihat CrmIsoSetting/TEARDOWN.md)
  "crm_iso.affected_providers": "Affected Providers",
  "crm_iso.affected_providers_desc":
    "Affected agents only see conversations from these providers' numbers. Numbers that don't match any provider are hidden.",
  "crm_iso.add_provider": "Add Provider",
  "crm_iso.col_provider": "Provider",
  "crm_iso.col_prefix": "Number Prefix",
  "crm_iso.empty_providers": "No providers yet",
  "crm_iso.select_provider": "Select provider",
  "crm_iso.select_provider_hint": "Select one or more providers to add.",
  "crm_iso.division": "Division",
  "crm_iso.division_all": "All divisions",
  "crm_iso.division_filter_hint":
    "Optional. Filter main & linked agent options by division.",
  // [crm-iso] END
  "error_page.updating_app": "Updating the app...",
  "error_page.updating_app_desc":
    "Loading the latest version, the page will reload automatically.",
  "error_page.update_failed": "Failed to load the latest version",
  "error_page.update_failed_desc":
    "We tried to update the app automatically, but it did not succeed.",
  "error_page.reload": "Reload",
  "error_page.clear_cache_title": "Clear browser cache",
  "error_page.clear_cache_desc":
    "The latest version still failed to load. Clear your browser cache with the steps below.",
  "error_page.clear_cache_step_1":
    "Press Ctrl + Shift + Delete (Windows) or Cmd + Shift + Delete (Mac).",
  "error_page.clear_cache_step_2": 'Under "Time range", choose "All time".',
  "error_page.clear_cache_step_3":
    'Check only "Cached images and files". Uncheck the others so you stay logged in.',
  "error_page.clear_cache_step_4": 'Click "Delete data".',
  "error_page.clear_cache_footer":
    "Then click {{button}}. If it still fails, contact the CRM.id support team.",
  "inhouse_channel.send_message": "Send Inhouse Message",
  "notification.update_description":
    "Reload to get the latest features and fixes. It only takes a few seconds.",
  "notification.update_description_draft":
    "Finish the message or data you are filling in first. The new version will be installed automatically when you move to another page.",
  "notification.update_data_safe":
    "Your data is safe, this page will not reload on its own",
  "notification.update_reload": "Reload",
  "notification.update_confirm_title": "Reload now?",
  "notification.update_confirm_content":
    "Unsent messages or unsaved data on this page will be lost.",
  "notification.update_confirm_ok": "Reload anyway",
  "whatsapp.channel_section_title": "WhatsApp Channel",
  "whatsapp.channel_section_description":
    "Connect your WhatsApp Business number. Chats from customers will arrive in the inbox.",
  "whatsapp.add_card_title": "Add Channel",
  "whatsapp.add_card_desc": "Connect a WhatsApp number",
  "sider.channel": "Channel",
  "contact.filter_channel": "Channel",
  "contact.all_channel": "All channels",
  "contact.channel_whatsapp": "WhatsApp",
  "contact.channel_inhouse": "Inhouse",
  "template.no_channel_title": "No channel yet",
  "template.no_channel_description":
    "Templates can be created for both WhatsApp and Inhouse channels. Connect a channel first to create templates.",
  "template.button": "Buttons",
  "template.button_description":
    "Optional, up to {{value}} buttons. Buttons appear below the message.",
  "template.button_quick_reply": "Quick reply",
  "template.button_url": "Link",
  "template.button_text": "Button text",
  "template.button_text_required": "Button text is required",
  "template.button_url_required": "Link button URL is required",
  "template.button_url_invalid": "URL must start with http:// or https://",
  "template.button_url_hint":
    "For a dynamic link, add {{placeholder}} to the URL. Its value is filled in when the template is sent.",
  "template.button_url_placeholder_invalid":
    "The URL placeholder can only be {{placeholder}}, used once",
  "template.button_url_placeholder_single":
    "Only one link button can use {{placeholder}}",
  "template.button_add": "Add button",
  "template.button_param": 'Button parameter "{{value}}"',
  "template.button_param_required": "Button parameter is required",
  "inhouse_contact.title": "Inhouse data available",
  "inhouse_contact.multiple_users": "Found {{count}} users, select one:",
  "inhouse_contact.select_company": "Select company",
  "inhouse_contact.company": "Company",
  "inhouse_contact.apply": "Use this data",
  "inhouse_contact.applied": "Inhouse data applied, review before saving",
  "ticketing.inhouse_contact_title": "Select Contact from Inhouse Channel",
  "ticketing.inhouse_channel": "Inhouse Channel",
  "ticketing.select_inhouse_channel": "Select inhouse channel",
  "ticketing.inhouse_contact_tag": "Inhouse",
  "ticketing.inhouse_contact_info":
    "This contact comes from an inhouse channel",
  "reports.vi_detail_conversation": "Detail Conversation",
  "reports.vi_export_processing":
    "Export is being processed. The download link will be sent to this page and to your email once it's done.",
  "reports.vi_export_processing_title": "Export in progress",
  "reports.vi_export_success_title": "Export complete",
  "reports.vi_export_failed_title": "Export failed",
  "reports.vi_export_ready":
    "Your file is ready to download. The link is valid for 1 day and has also been sent to your email.",
  "reports.vi_export_download_here": "Download here",
  "reports.vi_export_download_part": "Download file {{number}}",
};

const data = {
  locale: "en-US",
  antdData,
  messages,
};

export default data;
